import React, { useEffect, useMemo, useRef, useState } from "react";
import Sidebar from "../../components/Sidebar";
import DashboardDoctorHeader from "../../components/MainHeader/DashboardDoctorHeader";
import PaymentQuickAccess from "../../components/consultation/PaymentQuickAccess";
import Calendar from "react-calendar";
import ChatAttachIcon from "../../assets/images/appointment-attach-icon.svg";
import expandIconfrom from "../../assets/images/expand-icon.svg";
import leftArrowImg from "../../assets/images/left-arrow.svg";
import rightArrowImg from "../../assets/images/right-arrow.svg";
import CrossIcon from "../../assets/images/CrossIcon.svg";
import downloadIcon from "../../assets/images/download.svg";
import whiteDownloadIcon from "../../assets/images/white-download.svg";
import whiteImageIcon from "../../assets/images/white-image-icon.svg";
import blackImageIcon from "../../assets/images/black-image-icon.svg";
import whitePdfIcon from "../../assets/images/white-pdf-icon.svg";
import blackPdfIcon from "../../assets/images/black-pdf-icon.svg";
import whiteDocxIcon from "../../assets/images/white-docx-icon.svg";
import blackDocxIcon from "../../assets/images/black-docx-icon.svg";
import editIcon from "../../assets/images/edit-icon2.svg";
import NoImage from "../../assets/images/no-image-avatar.png";
import { toast } from "react-toastify";
import { useCities } from "@/queries/useLocalisationQuery"
import AddFamilyMemberModal from "./modals/AddFamilyMemberModal";


import PatientDetailsCard from "./patient-dictionary/components/patient-details-card.jsx";
import {
  AppointmentList,
  mapAppointmentToCardModel,
} from "./patient-dictionary/components/appointment-card.jsx";
import ChatWithPatientCard from "./patient-dictionary/components/chat-with-patient-card.jsx";
import {
  addPrescriptionContentApi,
  fetchHolidayApi,
  appointmentDetailsApi,
  cancelAppointmentApi,
  cityListApi,
  createDictionaryNoteApi,
  createGlobalNoteApi,
  dateAvailabilityApi,
  deletePrescriptionApi,
  doctorAddPatientMemberApi,
  doctorEditPhoneNumberApi,
  fetchDoctorMessageDetailsApi,
  fetchPrescriptionContentApi,
  getAppointmentMessageApi,
  getCancelReasonApi,
  getDoctorAllTemplateApi,
  getDoctorForSearchApi,
  getPatientDictionaryDetailsApi,
  getRescheduleReasonApi,
  myAccountDetailsApi,
  patientFamilyListApi,
  readDoctorMessageApi,
  rescheduleAppointmentApi,
  searchMedicalTestApi,
  searchMedicinesDetailsApi,
  showPrescriptorPrescriptionApi,
  updatePriorityApi,
  updatePatientFromDoctorByPatientIdApi,
} from "../../services/apiService";
import { fetchChartssList } from "../../services/observationService";
import {
  getChartObservation,
  listPatientWeights,
  listPatientWeightss,
} from "../../services/apiService";
import {
  listDoctorProtocolsoins,
  listDoctorProtocolsoinss,
} from "../../services/stockProtocolService";
import { fetchDocsWithSignedUrlsApi } from "../../services/documentService";
import { Link, useNavigate, useParams } from "react-router";
import cancelIcon from "../../assets/images/cancel-btn.svg";
import patientDictonaryProfileImg from "../../assets/images/patient-dictonary-profile-img.png";
import appointmentAttachIcon from "../../assets/images/appointment-attach-icon.svg";
import { format } from "date-fns";
import Skeleton from "react-loading-skeleton";
import JoditEditor from "jodit-react";
import EmojiPicker from "emoji-picker-react";
import LoadingPage from "../../components/LoadingPage";
import moment from "moment";
import Tooltip from "@mui/material/Tooltip";
import {
  chatMessgaeDateFormat,
  getFileExtension,
  isPreviousDateFromCurrent,
} from "../../utils/commonData";
import { CircularProgress } from "@mui/material";
import { useUserContext } from "../../context/UserContext";
import { IMAGE_URL } from "../../app_url";
import ChatWithDoctorCard from "./patient-dictionary/components/chat-with-doctor-card.jsx";
import GlobalNotesList from "./patient-dictionary/components/global-notes-list.jsx";

const useOnClickOutside = (ref, handler) => {
  useEffect(() => {
    const listener = (event) => {
      if (!ref.current || ref.current.contains(event.target)) {
        return; // Click is inside the element, do nothing.
      }
      handler(); // Click is outside, call the handler.
    };

    document.addEventListener("mousedown", listener);
    return () => {
      document.removeEventListener("mousedown", listener);
    };
  }, [ref, handler]);
};

const htmlToPlainText = (value) => {
  if (value === null || value === undefined) return "";
  const raw = String(value);
  if (!raw.trim()) return "";

  if (typeof document !== "undefined") {
    const wrapper = document.createElement("div");

    // Pre-process structural tags into actual newlines before assigning to DOM
    const processedRaw = raw
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<\/p>/gi, "\n\n") // Use double newline for paragraphs
      .replace(/<\/div>/gi, "\n");

    wrapper.innerHTML = processedRaw;

    return String(wrapper.textContent || wrapper.innerText || "")
      .replace(/\u00a0/g, " ")
      .trim();
  }

  // Fallback for non-browser environments (like Node.js)
  return raw
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<\/p>/gi, "\n\n")
    .replace(/<\/div>/gi, "\n")
    .replace(/<[^>]*>/g, " ")
    .replace(/\u00a0/g, " ")
    .replace(/[ \t]+/g, " ") // Collapse horizontal spaces only
    .split(/\n\s*\n/)       // Split by multiple newlines
    .map(p => p.trim())
    .join("\n")             // Rejoin with single newlines
    .trim();
};

const parsePrescriptionNotesObject = (rawNotes) => {
  if (!rawNotes) return null;
  if (typeof rawNotes === "object") return rawNotes;
  try {
    return JSON.parse(rawNotes);
  } catch {
    return null;
  }
};

const formatAnalysesLinesByFamily = (items = []) => {
  const grouped = new Map();
  items.forEach((item) => {
    const name = String(item?.name || item?.medical_test || "").trim();
    if (!name) return;
    const family = String(
      item?.group || item?.family || item?.group_name || "Autres",
    ).trim() || "Autres";
    if (!grouped.has(family)) grouped.set(family, []);
    grouped.get(family).push(name);
  });
  return Array.from(grouped.values()).map((names) => `- ${names.join(", ")}`);
};

const buildPrescriptionDisplayText = (prescription, profile = {}) => {
  const notesObj = parsePrescriptionNotesObject(prescription?.notes);
  const rawHtml =
    prescription?.content ||
    prescription?.prescription_body ||
    notesObj?.body_html ||
    prescription?.description ||
    "";

  const analysesItems = Array.isArray(prescription?.analyses_items)
    ? prescription.analyses_items
    : Array.isArray(notesObj?.items)
      ? notesObj.items
      : [];

  const analysesLines = formatAnalysesLinesByFamily(analysesItems);
  const analysesText = analysesLines.join("\n");

  const doctorDisplay = String(profile?.doctor_name || "").trim();
  const currentDate = new Date().toLocaleDateString("fr-FR");
  const text = htmlToPlainText(rawHtml)
    .replace(/\[PATIENT\]/gi, profile?.name || "")
    .replace(/\[DATE_NAISSANCE\]/gi, profile?.birth_date || "")
    .replace(/\[AGE\]/gi, profile?.age || "")
    .replace(/\[SEXE\]/gi, profile?.sex || "")
    .replace(/\[DATE\]/gi, currentDate)
    .replace(/\[DOCTEUR\]/gi, doctorDisplay ? `Dr. ${doctorDisplay}` : "")
    .replace(/\[(TESTS?|ANALYSES?)\]/gi, analysesText)
    .replace(/[ \t]{2,}/g, " ")
    .trim();

  return text;
};

const toPositiveInteger = (value) => {
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
};

const formatDetailedDosageSegment = (line = {}) => {
  const dosage = line?.dosage || {};
  const rawDose = dosage?.dose ?? line?.dose;
  const dose =
    rawDose !== null && rawDose !== undefined && String(rawDose).trim() !== ""
      ? String(rawDose).trim()
      : "";
  const unit = String(dosage?.unit ?? line?.unite ?? "").trim();
  const frequency = String(dosage?.frequency ?? line?.frequence ?? "").trim();
  const route = String(dosage?.route ?? line?.voie ?? "").trim();
  const moment = String(dosage?.moment ?? line?.moment ?? "").trim();
  const meal = String(dosage?.meal ?? line?.repas ?? "").trim();
  const durationValue = String(dosage?.duration_value ?? line?.duree_valeur ?? "").trim();
  const durationUnit = String(dosage?.duration_unit ?? line?.duree_unite ?? "").trim();
  const conditionText = String(dosage?.condition_text ?? line?.condition ?? "").trim();
  const renewal = String(dosage?.renewal ?? line?.renouvellement ?? "").trim();
  const notes = String(dosage?.notes ?? line?.notes ?? "").trim();

  const segments = [];
  const dosePart = [dose, unit].filter(Boolean).join(" ");
  if (dosePart) segments.push(dosePart);
  if (frequency) segments.push(frequency);
  if (route) segments.push(route);
  if (moment) segments.push(moment);
  if (meal) segments.push(meal);

  // Handle duration with calendar logic like mapPrescriptorLineToText
  if (durationUnit === "calendar") {
    const start = String(dosage?.duree_calendar_start ?? line?.duree_calendar_start ?? "").trim();
    const end = String(dosage?.duree_calendar_end ?? line?.duree_calendar_end ?? "").trim();
    const calRange = [start ? `j${start}` : "", end ? `j${end}` : ""].filter(Boolean).join(" -> ");
    if (calRange) segments.push(calRange);
  } else if (durationValue || durationUnit) {
    segments.push([durationValue, durationUnit].filter(Boolean).join(" "));
  }

  if (conditionText) {
    const cond = conditionText.trim();
    segments.push(cond.toLowerCase().startsWith("si ") ? cond : `si ${cond}`);
  }
  if (renewal) segments.push(renewal);
  if (notes) segments.push(notes);

  return segments.join(", ");
};

const flattenDetailedBlocks = (blocks = []) => {
  const output = [];
  blocks.forEach((block) => {
    output.push(block);
    const children = Array.isArray(block?.children) ? block.children : [];
    output.push(...flattenDetailedBlocks(children));
  });
  return output;
};

const buildMedicineLinesFromDetailedPrescriptor = (detailedPrescription) => {
  const entries = Array.isArray(detailedPrescription?.entries)
    ? detailedPrescription.entries
    : [];
  if (!entries.length) return [];

  const output = [];
  entries.forEach((entry) => {
    const blocks = flattenDetailedBlocks(Array.isArray(entry?.blocks) ? entry.blocks : []);
    blocks.forEach((block) => {
      const medName = normalizeInlineText(block?.medication_name || block?.medicament?.name || "");
      if (!medName) return;

      const quantity = block?.quantity;
      const quantityUnit = normalizeInlineText(block?.quantity_unit || block?.type_quantite || "");
      const quantityPart =
        quantity !== null && quantity !== undefined && String(quantity).trim() !== ""
          ? `qté: ${String(quantity).trim()}${quantityUnit ? ` ${quantityUnit}` : ""}`
          : "";

      const lineItems = Array.isArray(block?.lines) ? block.lines : [];
      const dosageLines = lineItems
        .map((line) => {
          const type = String(line?.line_type || line?.type || "").trim().toLowerCase();
          if (type === "test_line") {
            const tests = Array.isArray(line.tests)
              ? line.tests.map(t => String(t?.name || t?.label || t).trim()).filter(Boolean)
              : [];
            return tests.length ? `Tests: ${tests.join(", ")}` : "Tests";
          }
          if (type === "condition_line") {
            const parts = [line.expression, line.action_type, line.action_medication].filter(Boolean);
            return parts.join(" | ");
          }
          return formatDetailedDosageSegment(line);
        })
        .filter(Boolean);

      output.push({
        name: medName,
        quantity: quantityPart,
        dosageLines: dosageLines,
      });
    });
  });

  return output;
};

const normalizeInlineText = (value) =>
  String(value || "")
    .replace(/\s+/g, " ")
    .trim();

const isMedicationHeadingLine = (line) => {
  const text = normalizeInlineText(line);
  if (!text) return false;

  // Metadata lines should always start a new block
  if (/^(Ordonnance|Modele Prescriptor|Modèle Prescriptor|Prescription|Note)\b/i.test(text)) {
    return true;
  }

  // Common dosage patterns that are definitely NOT medication names
  if (/^(\d+|un|une|chaque)\s*(gtt|bouf|app|rinçage|rincage|pulv|spray|c\.à\.c|c\.à\.s|comprimé|capsule|ampoule|sachet|unité|unite|dose|ddp|ml|mg|µg|ug|g|ui|fois|x|par)\b/i.test(text)) {
    return false;
  }

  // Keywords that usually start a dosage instruction
  if (/^(puis|note|nombre|periode|période|moment|durée|duree|voie|matin|midi|soir|nuit|pendant|durant|si|en\scas)\b/i.test(text)) {
    return false;
  }

  // If it's mostly uppercase, it's very likely a medication name
  const letters = text.replace(/[^A-Za-zÀ-ÿ]/g, "");
  if (letters.length >= 3) {
    const upperCount = letters.split("").filter(ch => ch === ch.toUpperCase()).length;
    if (upperCount / letters.length >= 0.65) return true;
  }

  // If it starts with an uppercase letter and has a dosage-like pattern at the end
  if (/^[A-ZÀ-ÿ].*\b\d+\s*(mg|g|ml|%|µg|ui|ug)\b/i.test(text)) {
    return true;
  }

  // Fallback
  if (text.length > 0 && text[0] === text[0].toUpperCase() && text.length < 200) {
    return true;
  }

  return false;
};

const buildMedicineDisplayLines = (
  prescription,
  profile = {},
  detailedPrescription = null,
) => {
  const detailedLines = buildMedicineLinesFromDetailedPrescriptor(
    detailedPrescription,
  );
  if (detailedLines.length > 0) return detailedLines;

  const resolvedText = buildPrescriptionDisplayText(prescription, profile);
  const lines = String(resolvedText || "")
    .split(/\r?\n/)
    .map(normalizeInlineText)
    .filter(Boolean);

  const grouped = [];
  let current = null;

  lines.forEach((line) => {
    if (isMedicationHeadingLine(line)) {
      if (current) grouped.push(current);

      let name = line;
      let quantity = "";
      const qteMatch = line.match(/^(.*?)\s*[-–—]\s*(?:Qte|Qté):\s*(.*)$/i);
      if (qteMatch) {
        name = qteMatch[1].trim();
        quantity = `qté: ${qteMatch[2].trim()}`;
      }

      current = { name, quantity, dosageLines: [] };
      return;
    }

    if (current) {
      current.dosageLines.push(line);
    } else {
      // If we haven't found a heading yet, but have text, treat it as a medication name
      grouped.push({ name: line, quantity: "", dosageLines: [] });
    }
  });

  if (current) grouped.push(current);

  if (grouped.length > 0) return grouped;

  const legacyLines = String(prescription?.medicine || "")
    .split("//")
    .map(normalizeInlineText)
    .filter(Boolean);

  if (legacyLines.length > 0) {
    return legacyLines.map((l) => ({ name: l, dosageLines: [] }));
  }

  const fallback = normalizeInlineText(resolvedText);
  return fallback ? [{ name: fallback, dosageLines: [] }] : [];
};

const MedicineParserDisplay = ({
  text,
  profile,
  detailedPrescription = null,
}) => {
  if (!text && !detailedPrescription) return null;
  const plainText = text ? htmlToPlainText(text) : "";
  const lines = buildMedicineDisplayLines(
    { medicine: plainText },
    profile,
    detailedPrescription,
  );

  // If the parser only returned one line and it's the same as plainText,
  // it's likely not a prescription, so we show the original HTML.
  if (
    !detailedPrescription &&
    lines.length === 1 &&
    lines[0].name === plainText &&
    lines[0].dosageLines.length === 0
  ) {
    return (
      <h3
        style={{
          color: "#334155",
          fontSize: "14px",
          fontWeight: "500",
          lineHeight: "1.5",
        }}
        dangerouslySetInnerHTML={{ __html: text }}
      ></h3>
    );
  }

  return (
    <div
      style={{
        background: "#ffffff",
        color: "#1a237e",
        borderRadius: "10px",
        padding: "16px",
        flex: "1 1 300px",
        width: "auto",
        minWidth: "280px",
        maxWidth: "100%",
        border: "1px solid #e0e4f5",
        boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
      }}
    >
      {lines.map((med, medIdx) => (
        <div
          key={medIdx}
          style={{
            marginBottom: medIdx === lines.length - 1 ? 0 : "15px",
            borderBottom:
              medIdx === lines.length - 1 ? "none" : "1px solid #f0f2ff",
            paddingBottom: medIdx === lines.length - 1 ? 0 : "12px",
          }}
        >
          <div
            style={{
              fontSize: "15px",
              fontWeight: "700",
              color: "#334155",
              textTransform: "uppercase",
              marginBottom: "2px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            {med.name}
            {med.quantity && (
              <span
                style={{
                  fontWeight: "500",
                  fontSize: "13px",
                  color: "#94a3b8",
                  backgroundColor: "transparent",
                  padding: 0,
                  display: "inline",
                  textTransform: "uppercase",
                }}
              >
                ({med.quantity})
              </span>
            )}
          </div>
          {med.dosageLines && med.dosageLines.length > 0 ? (
            <div
              style={{ display: "flex", flexDirection: "column", gap: "2px" }}
            >
              {med.dosageLines.map((line, lineIdx) => (
                <div
                  key={lineIdx}
                  style={{
                    fontSize: "14px",
                    lineHeight: "1.5",
                  }}
                >
                  {(() => {
                    const parts = line.split(", ");
                    const firstPart = parts[0];
                    const rest = parts.slice(1).join(", ");

                    return (
                      <>
                        <span
                          style={{
                            color: "#e11d48",
                            fontWeight: "700",
                            backgroundColor: "transparent",
                            padding: 0,
                            display: "inline",
                          }}
                        >
                          {firstPart}
                        </span>
                        {rest ? (
                          <span
                            style={{
                              color: "#64748b",
                              fontWeight: "400",
                              backgroundColor: "transparent",
                              padding: 0,
                              display: "inline",
                            }}
                          >
                            , {rest}
                          </span>
                        ) : null}
                      </>
                    );
                  })()}
                </div>
              ))}
            </div>
          ) : null}
        </div>
      ))}
    </div>
  );
};

const NewPatientDictonary = () => {
  const { userData } = useUserContext();
  const navigate = useNavigate();
  const { appId, patientId } = useParams();
  const editor = useRef(null);
  const editor2 = useRef(null);
  const editor3 = useRef(null);
  const emojiPickerRef = useRef(null);
  const emojiPickerRef2 = useRef(null);
  const emojiPickerRef3 = useRef(null);
  const medicineResultRef = useRef(null);
  const testResultRef = useRef(null);
  const showKidsRef = useRef(null);

  //
  const [activeIndexes, setActiveIndexes] = useState([0, 1, 2]);
  const [cancelReasonList, setCancelReasonList] = useState();
  const [rescheduleReasonList, setRescheduleReasonList] = useState();
  const [cancelReason, setCancelReason] = useState();
  const [rescheduleReason, setRescheduleReason] = useState();
  const [modalBtnDis, setModalBtnDis] = useState(false);
  const [reschedulePopupShow, setReschedulePopupShow] = useState(false);
  const [calendarValue, setCalendarValue] = useState(new Date());
  const [availDates, setAvailDates] = useState();
  const [selectedTime, setSelectedTime] = useState();
  const [allDetails, setAllDetails] = useState();
  const [allAppDetails, setAllAppDetails] = useState();
  const [appointmentDetails, setAppointmentDetails] = useState();
  const [screenLoading, setScreenLoading] = useState(false);
  const [screenLoading1, setScreenLoading1] = useState(false);
  const [skelLoading, setSkelLoading] = useState(false);
  const [futureDate, setFutureDate] = useState();
  const [bookedAppoinment, setBookedAppoinment] = useState();
  const [messageList, setMessageList] = useState([]);
  const [toDoctorSearchText, setToDoctorSearchText] = useState(null);
  const [toDoctorSearchList, setToDoctorSearchList] = useState();
  const [toDoctorSearchLoader, setToDoctorSearchLoader] = useState(false);
  const [messageSenderObj, setMessageSenderObj] = useState();
  const [lastScrollTop, setLastScrollTop] = useState(0);
  const [alertShown, setAlertShown] = useState(false);
  const [toDoctorAndReferList, setToDoctorAndReferList] = useState({
    doctorList: [],
    referList: [],
  });
  const [showMedicineList, setShowMedicineList] = useState(false);
  const [showTestList, setShowTestList] = useState(false);
  const [searchMedicineTerm, setSearchMedicineTerm] = useState();
  const [searchTestTerm, setSearchTestTerm] = useState();
  const [searchMedicineList, setSearchMedicineList] = useState();
  const [searchTestList, setSearchTestList] = useState();
  const [templateList, setTemplateList] = useState();
  const [medicineSearchLoad, setMedicineSearchLoad] = useState(false);
  const [testSearchLoad, setTestSearchLoad] = useState(false);
  const [medicineTimeoutId, setMedicineTimeoutId] = useState(null);
  const [testTimeoutId, setTestTimeoutId] = useState(null);
  const [selectedMedicineObject, setSelectedMedicineObject] = useState({});
  const [selectedTemplateId, setSelectedTemplateId] = useState();
  const [saveBtnDis, setSaveBtnDis] = useState(false);
  const [savedTemplateList, setSavedTemplateList] = useState([]);
  const [selectedTemplateEdit, setSelectedTemplateEdit] = useState();
  const [screenLoadingBlur, setScreenLoadingBlur] = useState(false);
  const [showDeleteTempPopup, setShowDeleteTempPopup] = useState(false);
  const [deleteBtnDis, setDeleteBtnDis] = useState(false);
  const [selectedTemplateCategory, setSelectedTemplateCategory] = useState();
  const [prescriptionDate, setPrescriptionDate] = useState({
    name: "",
    date: new Date().toISOString().split("T")[0],
    age: "",
    gender: "",
  });

  const [prescriptionContent, setPrescriptionContent] = useState("");
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [showEmojiPicker1, setShowEmojiPicker1] = useState(false);
  const [showEmojiPicker2, setShowEmojiPicker2] = useState(false);

  const [allPatientDetails, setAllPatientDetails] = useState();
  const [allPatientChildDetails, setAllPatientChildDetails] = useState();
  const [patientFamilyList, setPatientFamilyList] = useState([]);
  // track expanded appointment by its id (stable across re-renders)
  const [expandAppointmentId, setExpandAppointmentId] = useState(null);

  // Debug: log expand changes to help diagnose unexpected collapses
  useEffect(() => {
    try {
      console.debug(
        "[PatientDictonary] expandAppointmentId ->",
        expandAppointmentId,
      );
    } catch (e) { }
  }, [expandAppointmentId]);
  const [globalNote, setGlobalNote] = useState();
  const [prevGlobalNote, setPrevGlobalNote] = useState();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const [selectedAppForNote, setSelectedAppForNote] = useState();
  const [appForNoteText, setAppForNoteText] = useState();
  const [popupBtnDis, setPopupBtnDis] = useState(false);
  const [searchLoad, setSearchLoad] = useState(false);
  const [addPatientObject, setAddPatientObject] = useState();
  const [cityList, setCityList] = useState([]);
  const [showChangePhoneModal, setShowChangePhoneModal] = useState(false);
  const [newPhoneNumber, setNewPhoneNumber] = useState();
  const [startUnschedulePopupOpen, setStartUnschedulePopupOpen] =
    useState(false);
  const [addAppObject, setAddAppObject] = useState({});
  const [childId, setChildId] = useState();
  const [selectedDates, setSelectedDates] = useState([]);
  const [showAddKidsSection, setShowAddKidsSection] = useState(false);
  const [showPaymentSection, setShowPaymentSection] = useState(false);
  const [isEditingAddress, setIsEditingAddress] = useState(false);
  const [editedAddress, setEditedAddress] = useState("");
  const [isEditingPhone, setIsEditingPhone] = useState(false);
  const [editedPhone, setEditedPhone] = useState("");

  useOnClickOutside(emojiPickerRef, () => setShowEmojiPicker(false));
  useOnClickOutside(emojiPickerRef2, () => setShowEmojiPicker1(false));
  useOnClickOutside(emojiPickerRef3, () => setShowEmojiPicker2(false));
  useOnClickOutside(medicineResultRef, () => setShowMedicineList(false));
  useOnClickOutside(testResultRef, () => setShowTestList(false));
  useOnClickOutside(showKidsRef, () => setShowAddKidsSection(false));

  const daysarray = [];
  for (let i = 1; i <= 31; i++) {
    daysarray.push(i < 10 ? "0" + i : i);
  }

  const currentYear = new Date().getFullYear();
  const startYear = currentYear - 100;
  const years = [];

  for (let year = startYear; year <= currentYear; year++) {
    years.push(year);
  }

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const toggleAccordion = (index) => {
    if (activeIndexes.includes(index)) {
      setActiveIndexes(activeIndexes.filter((i) => i !== index));
    } else {
      setActiveIndexes([...activeIndexes, index]);
    }
  };

  // Load care steps and documents only (no charts) - used by "All Entries" click to avoid loading charts
  const loadAppointmentCareStepsOnly = async (appointmentId) => {
    if (!appointmentId || !DOC_doctorId || !patientId) return;
    try {
      // Load prescription content for this appointment
      try {
        const prescriptionFd = new FormData();
        prescriptionFd.append("appointment_id", appointmentId);
        const prescriptionResponse =
          await fetchPrescriptionContentApi(prescriptionFd);
        const prescriptionList =
          prescriptionResponse?.data?.res === true &&
            Array.isArray(prescriptionResponse?.data?.data)
            ? prescriptionResponse.data.data
            : [];
        setAppointmentPrescriptionContent((prev) => ({
          ...prev,
          [appointmentId]: prescriptionList,
        }));
      } catch (err) {
        setAppointmentPrescriptionContent((prev) => ({
          ...prev,
          [appointmentId]: [],
        }));
      }

      // Load care steps (appointment-scoped)
      try {
        const allSteps =
          typeof listDoctorProtocolsoinss === "function"
            ? await listDoctorProtocolsoinss(DOC_doctorId, {
              patientId,
              appointmentId,
            })
            : await listDoctorProtocolsoins(DOC_doctorId, {
              patientId,
              appointmentId,
            });
        const filteredSteps = Array.isArray(allSteps) ? allSteps : [];
        setAppointmentCareSteps((prev) => ({
          ...prev,
          [appointmentId]: filteredSteps,
        }));
      } catch (err) {
        setAppointmentCareSteps((prev) => ({ ...prev, [appointmentId]: [] }));
      }

      // Load documents for this appointment (no chart/network calls)
      try {
        const data = await fetchDocsWithSignedUrlsApi(
          DOC_doctorId,
          appointmentId,
        );
        const docList = Array.isArray(data?.data?.data)
          ? data.data.data
          : Array.isArray(data?.data)
            ? data.data
            : [];
        setAppointmentDocs((prev) => ({ ...prev, [appointmentId]: docList }));
      } catch (err) {
        setAppointmentDocs((prev) => ({ ...prev, [appointmentId]: [] }));
      }
    } catch (err) {
      console.error("[loadAppointmentCareStepsOnly] error", err);
    }
  };

  // Tab visibility
  const [activeTab, setActiveTab] = useState("observations");

  //
  const [showProfileModal, setShowProfileModal] = useState(false);

  const toggleProfileMoadl = () => {
    setShowProfileModal(!showProfileModal);
  };

  const [showAddIndicator, setShowAddIndicator] = useState(false);

  const toggleAddIndicator = () => {
    setShowAddIndicator(!showAddIndicator);
  };

  const [showEditIndicator, setShowEditIndicator] = useState(false);

  const toggleEditIndicator = () => {
    setShowEditIndicator(!showEditIndicator);
  };

  const [showRemoveIndicator, setShowRemoveIndicator] = useState(false);

  const toggleRemoveIndicator = () => {
    setShowRemoveIndicator(!showRemoveIndicator);
  };

  const [showRemoveMedicalBackgroundItem, setShowRemoveMedicalBackgroundItem] =
    useState(false);

  const toggleRemoveMedicalBackgroundItem = () => {
    setShowRemoveMedicalBackgroundItem(!showRemoveMedicalBackgroundItem);
  };

  const [showMedicalReport, setShowMedicalReport] = useState(false);

  const toggleMedicalReport = () => {
    setShowMedicalReport(!showMedicalReport);
  };

  const [selectedPresPopup, setSelectedPresPopup] = useState();

  // Track expanded prescriptions by appointmentId-prescriptionIndex
  const [expandedPrescriptions, setExpandedPrescriptions] = useState({});
  const [prescriptorPrescriptionDetails, setPrescriptorPrescriptionDetails] =
    useState({});

  const loadPrescriptorPrescriptionDetails = async (prescriptionId) => {
    const numericPrescriptionId = toPositiveInteger(prescriptionId);
    if (!numericPrescriptionId) return;

    try {
      const response = await showPrescriptorPrescriptionApi(
        numericPrescriptionId,
      );
      const detailedPrescription =
        response?.data?.data || response?.data || null;
      if (!detailedPrescription) return;

      setPrescriptorPrescriptionDetails((prev) => ({
        ...prev,
        [String(numericPrescriptionId)]: detailedPrescription,
      }));
    } catch (error) {
      console.debug(
        "[PatientDictonary] Unable to load detailed prescriptor prescription",
        prescriptionId,
        error,
      );
    }
  };

  const togglePrescription = (appointmentId, presIdx, presItem) => {
    const key = `${appointmentId}-${presIdx}`;
    const willExpand = !expandedPrescriptions[key];
    setExpandedPrescriptions((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));

    if (willExpand) {
      const numericPrescriptionId = toPositiveInteger(presItem?.id);
      const detailKey = String(numericPrescriptionId || "");
      if (
        numericPrescriptionId &&
        !prescriptorPrescriptionDetails[detailKey]
      ) {
        loadPrescriptorPrescriptionDetails(numericPrescriptionId);
      }
    }
  };
  const [showFamilyPopup, setShowFamilyPopup] = useState(false);

  // Care steps and charts for Medical Report
  const [careSteps, setCareSteps] = useState([]);
  const [properties, setProperties] = useState([]);
  const [chartDetails, setChartDetails] = useState({});
  const [latestWeightsGroups, setLatestWeightsGroups] = useState({});
  const [latestWeightsMap, setLatestWeightsMap] = useState({});

  // Store care steps and charts per appointment for display in profile
  const [appointmentCareSteps, setAppointmentCareSteps] = useState({});
  const [appointmentProperties, setAppointmentProperties] = useState({});
  const [appointmentChartDetails, setAppointmentChartDetails] = useState({});
  const [appointmentLatestWeightsGroups, setAppointmentLatestWeightsGroups] =
    useState({});
  const [appointmentLatestWeightsMap, setAppointmentLatestWeightsMap] =
    useState({});

  // Chart data per appointment (pour affichage grouped)
  const [appointmentModalChartData, setAppointmentModalChartData] = useState(
    {},
  );
  const [appointmentModalChartLoading, setAppointmentModalChartLoading] =
    useState({});

  // Documents per appointment
  const [appointmentDocs, setAppointmentDocs] = useState({});
  const [appointmentPrescriptionContent, setAppointmentPrescriptionContent] =
    useState({});

  // Track which appointments have already been loaded to avoid redundant network calls
  const [loadedAppointments, setLoadedAppointments] = useState({});

  // Feature flag to enable/disable charts UI and related network calls
  // Set to true to show charts (uses cached appointmentModalChartData and properties)
  // For this task we disable charts integration and show only the "Protocole de soin" display
  const SHOW_CHARTS = true;

  // target date normalized for modal filtering (YYYY-MM-DD)
  const targetDateNorm =
    (selectedPresPopup?.created_at ??
      selectedPresPopup?.createdAt ??
      selectedPresPopup?.appointment_date ??
      selectedPresPopup?.date)
      ? moment(
        selectedPresPopup?.created_at ??
        selectedPresPopup?.createdAt ??
        selectedPresPopup?.appointment_date ??
        selectedPresPopup?.date,
      ).format("YYYY-MM-DD")
      : null;

  // appointment_id from selected prescription/appointment
  const selectedAppointmentId =
    selectedPresPopup?.appointment_id ?? selectedPresPopup?.id ?? null;

  const DOC_doctorId = React.useMemo(() => {
    try {
      const raw = localStorage.getItem("doctolikLoginInfo");
      if (!raw) return null;
      const v = JSON.parse(raw);
      return (
        v?.users?.id ??
        v?.user?.id ??
        v?.doctor?.id ??
        v?.data?.user?.id ??
        null
      );
    } catch {
      return null;
    }
  }, []);

  const dictionaryPatientProfile = useMemo(() => {
    const source =
      childId && allPatientChildDetails?.data?.[0]
        ? allPatientChildDetails.data[0]
        : allPatientDetails?.data?.[0] || {};

    const firstName = String(source?.first_name || "").trim();
    const lastName = String(source?.last_name || "").trim();
    const fullName = String(source?.name || `${firstName} ${lastName}`)
      .trim()
      .replace(/\s{2,}/g, " ");

    return {
      name: fullName,
      age: String(source?.age || "").trim(),
      birth_date: String(
        source?.birth_date || source?.date_of_birth || source?.dob || "",
      ).trim(),
      sex: String(source?.gender || source?.sex || "").trim(),
      doctor_name: String(userData?.users?.name || "").trim(),
    };
  }, [childId, allPatientChildDetails, allPatientDetails, userData?.users?.name]);

  const appointmentCardItems = useMemo(() => {
    const sourceAppointments = childId && allPatientChildDetails
      ? allPatientChildDetails?.Appointment
      : allPatientDetails?.Appointment;

    return (sourceAppointments || [])
      .filter(
        (appointment) =>
          parseInt(appointment?.doctor_id) === parseInt(DOC_doctorId),
      )
      .map(mapAppointmentToCardModel);
  }, [DOC_doctorId, allPatientChildDetails, allPatientDetails, childId]);

  const loadAppointmentCardSection = React.useCallback(
    async (appointmentId, sectionName) => {
      if (!appointmentId || !DOC_doctorId || !patientId) return [];

      if (sectionName === "notes") {
        return appointmentCardItems.find((item) => item.id === appointmentId)
          ?.sections?.notes || [];
      }

      if (sectionName === "careProtocol") {
        const steps = typeof listDoctorProtocolsoinss === "function"
          ? await listDoctorProtocolsoinss(DOC_doctorId, { patientId, appointmentId })
          : await listDoctorProtocolsoins(DOC_doctorId, { patientId, appointmentId });
        return (Array.isArray(steps) ? steps : []).map((step, index) => ({
          id: step?.id || `${appointmentId}-step-${index}`,
          label: step?.service || step?.label || "Care step",
          done: Boolean(step?.is_done),
        }));
      }

      if (sectionName === "charts") {
        const response = await listPatientWeightss(
          DOC_doctorId,
          patientId,
          appointmentId,
        );
        const responseData = response?.data ?? response;
        const indicators = Array.isArray(responseData)
          ? responseData
          : responseData?.weights || responseData?.data || responseData?.items || [];
        return mapAppointmentToCardModel({ indicators }).sections.charts;
      }

      if (sectionName === "prescriptions") {
        const formData = new FormData();
        formData.append("appointment_id", appointmentId);
        const response = await fetchPrescriptionContentApi(formData);
        const prescriptionContent = response?.data?.res === true && Array.isArray(response?.data?.data)
          ? response.data.data
          : [];
        return mapAppointmentToCardModel({ id: appointmentId, prescription_content: prescriptionContent })
          .sections.prescriptions;
      }

      if (sectionName === "documents") {
        const response = await fetchDocsWithSignedUrlsApi(DOC_doctorId, appointmentId);
        const documents = Array.isArray(response?.data?.data)
          ? response.data.data
          : Array.isArray(response?.data)
            ? response.data
            : [];
        return documents.map((document, index) => ({
          id: document?.id || `${appointmentId}-document-${index}`,
          name: document?.name || document?.file_name || document?.original_name || "Document",
          type: document?.file_type || document?.type || document?.mime || "FILE",
          date: moment(document?.created_at || document?.date).format("D MMM YYYY"),
          url: document?.signed_url || document?.url || document?.file_path || "",
        }));
      }

      return [];
    },
    [DOC_doctorId, appointmentCardItems, patientId],
  );

  // Load care steps, chart properties and details when Medical Report modal opens
  React.useEffect(() => {
    if (!showMedicalReport || !selectedAppointmentId) return;
    let mounted = true;

    const load = async () => {
      try {
        // care steps - filtered by appointment_id
        let steps = [];
        try {
          const rawSteps =
            typeof listDoctorProtocolsoinss === "function"
              ? await listDoctorProtocolsoinss(DOC_doctorId, {
                patientId,
                appointmentId: selectedAppointmentId,
              })
              : await listDoctorProtocolsoins(DOC_doctorId, {
                patientId,
                appointmentId: selectedAppointmentId,
              });
          steps = Array.isArray(rawSteps) ? rawSteps : [];
        } catch (err) {
          console.warn("load careSteps failed", err);
          steps = [];
        }
        if (!mounted) return;
        setCareSteps(steps);

        // properties (charts)
        let list = [];
        if (SHOW_CHARTS) {
          // Only fetch properties from the API if we don't already have them
          if (!Array.isArray(properties) || properties.length === 0) {
            try {
              list = await fetchChartssList(DOC_doctorId, patientId);
              list = Array.isArray(list) ? list : [];
              if (!mounted) return;
              setProperties(list);
            } catch (err) {
              console.warn("fetchChartssList failed", err);
              list = [];
            }
          } else {
            // reuse already-loaded properties to avoid repeated network calls
            list = properties;
          }
        }

        // fetch per-chart details when points are missing
        const details = {};
        for (const p of list) {
          try {
            const raw = p?.raw ?? {};
            const points =
              raw?.points ??
              raw?.data ??
              raw?.values ??
              raw?.mesures ??
              raw?.measurements ??
              raw?.historique ??
              null;
            if (!Array.isArray(points) || points.length === 0) {
              const det = await getChartObservation(
                p.id,
                DOC_doctorId,
                patientId,
              );
              if (det) details[p.id] = det;
            }
          } catch (err) {
            console.debug("getChartObservation failed for", p?.id, err);
          }
        }
        if (!mounted) return;
        setChartDetails(details);

        // weights fallback - load both scoped (appointment-specific) and unscoped in parallel
        try {
          // Parallel load: scoped + unscoped weights
          const [scopedResp, unscopedResp] = await Promise.all([
            typeof listPatientWeightss === "function"
              ? listPatientWeightss(
                DOC_doctorId,
                patientId,
                selectedAppointmentId,
              )
              : Promise.resolve(null),
            typeof listPatientWeightss === "function"
              ? listPatientWeightss(DOC_doctorId, patientId, null)
              : listPatientWeights(DOC_doctorId, patientId),
          ]);

          const wgroups = {};
          const wmap = {};

          // Process scoped weights first (appointment-specific)
          const scopedRows = Array.isArray(scopedResp?.data)
            ? scopedResp.data
            : Array.isArray(scopedResp)
              ? scopedResp
              : [];
          for (const it of scopedRows) {
            const key = String(it?.parametre ?? it?.nom ?? it?.name ?? "")
              .trim()
              .toLowerCase();
            if (!key) continue;
            (wgroups[key] = wgroups[key] || []).push({
              value: it.value ?? it.valeur ?? it.poids ?? null,
              date: it.measured_at ?? it.date ?? it.created_at ?? null,
            });
            // Store latest for quick access
            if (
              !wmap[key] ||
              new Date(it.measured_at ?? it.date ?? it.created_at ?? 0) >
              new Date(wmap[key].date ?? 0)
            ) {
              wmap[key] = {
                value: it.value ?? it.valeur ?? it.poids ?? null,
                date: it.measured_at ?? it.date ?? it.created_at ?? null,
              };
            }
          }

          // Supplement with unscoped weights if key not found
          const unscopedRows = Array.isArray(unscopedResp?.data)
            ? unscopedResp.data
            : Array.isArray(unscopedResp)
              ? unscopedResp
              : [];
          for (const it of unscopedRows) {
            const key = String(it?.parametre ?? it?.nom ?? it?.name ?? "")
              .trim()
              .toLowerCase();
            if (!key || wgroups[key]) continue; // Skip if already have scoped data
            (wgroups[key] = wgroups[key] || []).push({
              value: it.value ?? it.valeur ?? it.poids ?? null,
              date: it.measured_at ?? it.date ?? it.created_at ?? null,
            });
            if (
              !wmap[key] ||
              new Date(it.measured_at ?? it.date ?? it.created_at ?? 0) >
              new Date(wmap[key].date ?? 0)
            ) {
              wmap[key] = {
                value: it.value ?? it.valeur ?? it.poids ?? null,
                date: it.measured_at ?? it.date ?? it.created_at ?? null,
              };
            }
          }

          if (!mounted) return;
          setLatestWeightsGroups(wgroups);
          setLatestWeightsMap(wmap);
        } catch (err) {
          console.debug("listPatientWeights failed", err);
        }
      } catch (err) {
        console.error("Error loading medical report data", err);
      }
    };

    load();
    return () => {
      mounted = false;
    };
  }, [showMedicalReport, DOC_doctorId, patientId, selectedAppointmentId]);

  const [showTemplateModal, setShowTemplateModal] = useState(false);

  const toggleTemplateModal = () => {
    setShowTemplateModal(!showTemplateModal);
  };

  const [DataObj, setDataObj] = useState([
    {
      id: 1,
      title: "Antecedents",
    },
    {
      id: 2,
      title: "Life style",
    },
    {
      id: 3,
      title: "Allergies",
    },
    {
      id: 4,
      title: "Current treatments",
    },
  ]);

  const [showAddMedicalBackground, setShowAddMedicalBackground] =
    useState(false);
  const [selectedId, setSelectedId] = useState();
  const [medicalBackgroundTitle, setMedicalBackgroundTitle] = useState();

  const toggleAddMedicalBackground = () => {
    setShowAddMedicalBackground(!showAddMedicalBackground);
  };

  // Load care steps and charts for a specific appointment
  const loadAppointmentCareStepsAndCharts = async (appointmentId) => {
    if (!appointmentId || !DOC_doctorId || !patientId) {
      console.warn(
        "Missing required params: appointmentId",
        appointmentId,
        "DOC_doctorId",
        DOC_doctorId,
        "patientId",
        patientId,
      );
      return;
    }

    console.log(
      `[loadAppointmentCareStepsAndCharts] START: appointmentId=${appointmentId} (type: ${typeof appointmentId})`,
    );

    try {
      // Load prescription content for this appointment
      try {
        const prescriptionFd = new FormData();
        prescriptionFd.append("appointment_id", appointmentId);
        const prescriptionResponse =
          await fetchPrescriptionContentApi(prescriptionFd);
        const prescriptionList =
          prescriptionResponse?.data?.res === true &&
            Array.isArray(prescriptionResponse?.data?.data)
            ? prescriptionResponse.data.data
            : [];
        setAppointmentPrescriptionContent((prev) => ({
          ...prev,
          [appointmentId]: prescriptionList,
        }));
      } catch (err) {
        setAppointmentPrescriptionContent((prev) => ({
          ...prev,
          [appointmentId]: [],
        }));
      }

      // Load care steps - trust the API to filter by appointmentId
      try {
        console.log("[CareSteps] Loading for appointment", appointmentId);
        const allSteps =
          typeof listDoctorProtocolsoinss === "function"
            ? await listDoctorProtocolsoinss(DOC_doctorId, {
              patientId,
              appointmentId,
            })
            : await listDoctorProtocolsoins(DOC_doctorId, {
              patientId,
              appointmentId,
            });

        const filteredSteps = Array.isArray(allSteps) ? allSteps : [];
        console.log(
          `[CareSteps] ✓ Loaded ${filteredSteps.length} care steps for appointment ${appointmentId}:`,
          filteredSteps,
        );
        setAppointmentCareSteps((prev) => ({
          ...prev,
          [appointmentId]: filteredSteps,
        }));
      } catch (err) {
        console.warn(
          "[CareSteps] ✗ Error loading for appointment",
          appointmentId,
          err?.message || err,
        );
        setAppointmentCareSteps((prev) => ({ ...prev, [appointmentId]: [] }));
      }

      // Load chart data using listPatientWeightss (appointment-scoped)
      if (SHOW_CHARTS) {
        try {
          console.log("[ChartData] Loading for appointment", appointmentId);
          setAppointmentModalChartLoading((prev) => ({
            ...prev,
            [appointmentId]: true,
          }));

          // Ensure we have chart properties to allow per-property fallbacks
          if (!Array.isArray(properties) || properties.length === 0) {
            try {
              const propsList = await fetchChartssList(DOC_doctorId, patientId);
              const normalized = Array.isArray(propsList) ? propsList : [];
              setProperties(normalized);
              setAppointmentProperties((prev) => ({
                ...prev,
                [appointmentId]: normalized,
              }));
              console.log(
                `[ChartData] Fetched ${normalized.length} properties for fallback`,
              );
            } catch (err) {
              console.debug(
                "[ChartData] fetchChartssList failed:",
                err?.message || err,
              );
            }
          }

          const response = await listPatientWeightss(
            DOC_doctorId,
            patientId,
            appointmentId,
          );
          let items = [];

          // Try multiple common shapes for the response
          const resData = response?.data ?? response ?? null;
          if (Array.isArray(resData)) {
            items = resData;
          } else if (resData && typeof resData === "object") {
            items =
              resData.weights ??
              resData.data ??
              resData.items ??
              resData.payload ??
              [];
          }
          items = Array.isArray(items) ? items : [];

          console.log(
            `[ChartData] ✓ Loaded ${items.length} appointment-scoped points for ${appointmentId}`,
          );

          // Log before storing to trace key mismatch
          console.log(
            `[ChartData] 🔑 Storing with KEY="${appointmentId}" (type: ${typeof appointmentId})`,
          );

          // If no appointment-scoped items, attempt to derive from chart properties details
          if (
            items.length === 0 &&
            Array.isArray(properties) &&
            properties.length > 0
          ) {
            try {
              const fallback = [];
              for (const p of properties) {
                try {
                  const det = await getChartObservation(
                    p.id,
                    DOC_doctorId,
                    patientId,
                  );
                  const raw = det?.raw ?? det ?? p?.raw ?? p;
                  const points =
                    raw?.points ??
                    raw?.data ??
                    raw?.values ??
                    raw?.measurements ??
                    raw?.historique ??
                    [];
                  if (Array.isArray(points) && points.length > 0) {
                    // pick points that match the appointmentId when present
                    const matched = points.filter(
                      (pt) => pt?.appointment_id == appointmentId,
                    );
                    for (const m of matched) {
                      fallback.push({
                        ...m,
                        property: p.nom ?? p.parametre ?? p.id,
                      });
                    }
                  }
                } catch (err) {
                  /* continue */
                }
              }
              if (fallback.length > 0) {
                console.log(
                  `[ChartData] ✓ Fallback found ${fallback.length} points from per-property observations for appointment ${appointmentId}`,
                );
                items = fallback;
              }
            } catch (err) {
              console.debug(
                "[ChartData] Fallback per-property fetch failed:",
                err?.message || err,
              );
            }
          }

          // store per-appointment results (store null when empty to explicitly mark no-charts)
          console.log(
            `[ChartData] 💾 Storing appointmentModalChartData[${appointmentId}] = ${items.length} items`,
          );
          setAppointmentModalChartData((prev) => ({
            ...prev,
            [appointmentId]: items.length > 0 ? items : null,
          }));
          if (items.length > 0) {
            // cache chart details mapping for this appointment (simple form)
            setAppointmentChartDetails((prev) => ({
              ...prev,
              [appointmentId]: { count: items.length },
            }));
          }
        } catch (err) {
          console.error(
            "[ChartData] ✗ Error loading for appointment",
            appointmentId,
            err?.message || err,
          );
          setAppointmentModalChartData((prev) => ({
            ...prev,
            [appointmentId]: null,
          }));
        } finally {
          setAppointmentModalChartLoading((prev) => ({
            ...prev,
            [appointmentId]: false,
          }));
        }
      } else {
        // Ensure chart data is empty when charts are disabled
        setAppointmentModalChartData((prev) => ({
          ...prev,
          [appointmentId]: null,
        }));
        setAppointmentModalChartLoading((prev) => ({
          ...prev,
          [appointmentId]: false,
        }));
      }

      // Load documents for this appointment
      try {
        const data = await fetchDocsWithSignedUrlsApi(
          DOC_doctorId,
          appointmentId,
        );
        const docList = Array.isArray(data?.data?.data)
          ? data.data.data
          : Array.isArray(data?.data)
            ? data.data
            : [];
        setAppointmentDocs((prev) => ({ ...prev, [appointmentId]: docList }));

        console.log(
          `[Docs] ✓ Loaded ${docList.length} documents for appointment ${appointmentId}`,
        );
      } catch (err) {
        console.warn(
          "[Docs] Error loading for appointment",
          appointmentId,
          err?.message || err,
        );
        setAppointmentDocs((prev) => ({ ...prev, [appointmentId]: [] }));
      }
    } catch (err) {
      console.error(
        "[LoadAppointment] Error loading care steps and charts:",
        err?.message || err,
      );
    }
  };

  // Helper function to get latest weight value from map - prioritizes appointment-specific values
  const getLatestFromMap = (property, appointmentId) => {
    if (!property || !appointmentId) return null;
    const wgroups = appointmentLatestWeightsGroups[appointmentId] ?? {};
    const candidates = [
      property?.nom,
      property?.parametre,
      property?.raw?.parametre,
      property?.raw?.nom,
    ];

    for (const cand of candidates) {
      const key = String(cand ?? "")
        .trim()
        .toLowerCase();
      if (key) {
        const weights = wgroups[key];
        if (Array.isArray(weights) && weights.length > 0) {
          const latest = weights[weights.length - 1];
          if (latest?.value || latest?.valeur || latest?.poids) {
            return latest.value ?? latest.valeur ?? latest.poids ?? latest;
          }
        }
      }
    }
    return null;
  };

  // Helper function to extract value from chart detail object - prioritizes appointment-scoped values
  const getValueFromChartDetail = (detailObj, appointmentId) => {
    if (!detailObj) return null;

    // Try to extract value from various possible locations
    const possibleValues = [
      detailObj?.value,
      detailObj?.valeur,
      detailObj?.poids,
      detailObj?.nombre,
      detailObj?.val,
      detailObj?.v,
      detailObj?.y,
      detailObj?.raw?.value,
      detailObj?.raw?.valeur,
      detailObj?.raw?.poids,
      detailObj?.raw?.val,
      detailObj?.raw?.v,
      detailObj?.raw?.y,
    ];

    // Check for arrays of values - prioritize values that match this appointment
    const arrayKeys = [
      "points",
      "data",
      "values",
      "mesures",
      "measurements",
      "historique",
      "observations",
    ];
    for (const key of arrayKeys) {
      if (Array.isArray(detailObj?.[key]) && detailObj[key].length > 0) {
        let targetPoint = null;
        if (appointmentId) {
          targetPoint =
            detailObj[key].find(
              (item) => item?.appointment_id == appointmentId,
            ) || detailObj[key][detailObj[key].length - 1];
        } else {
          targetPoint = detailObj[key][detailObj[key].length - 1];
        }
        const extracted =
          targetPoint?.value ??
          targetPoint?.valeur ??
          targetPoint?.poids ??
          targetPoint?.nombre ??
          targetPoint?.val ??
          targetPoint?.v ??
          targetPoint?.y;
        if (extracted != null) return extracted;
      }
      if (
        Array.isArray(detailObj?.raw?.[key]) &&
        detailObj.raw[key].length > 0
      ) {
        let targetPoint = null;
        if (appointmentId) {
          targetPoint =
            detailObj.raw[key].find(
              (item) => item?.appointment_id == appointmentId,
            ) || detailObj.raw[key][detailObj.raw[key].length - 1];
        } else {
          targetPoint = detailObj.raw[key][detailObj.raw[key].length - 1];
        }
        const extracted =
          targetPoint?.value ??
          targetPoint?.valeur ??
          targetPoint?.poids ??
          targetPoint?.nombre ??
          targetPoint?.val ??
          targetPoint?.v ??
          targetPoint?.y;
        if (extracted != null) return extracted;
      }
    }

    // Return first found value
    for (const val of possibleValues) {
      if (val != null) return val;
    }

    return null;
  };

  const buttonTitle = (item) => {
    toggleAddMedicalBackground();
    setMedicalBackgroundTitle(item.title);
    setSelectedId(item.id);
  };

  // Helper function to extract chart value with appointment prioritization
  const extractChartValue = (property, appointmentId) => {
    const raw = property?.raw ?? {};
    const points =
      raw?.points ??
      raw?.data ??
      raw?.values ??
      raw?.mesures ??
      raw?.measurements ??
      raw?.historique ??
      null;
    let value = "N/A";
    let foundValue = false;

    // Try 1: Get value from points in property - prioritize appointment-specific point
    if (Array.isArray(points) && points.length > 0) {
      let targetPoint =
        points.find((pt) => pt?.appointment_id == appointmentId) ||
        points[points.length - 1];
      const extractedValue =
        targetPoint?.value ??
        targetPoint?.valeur ??
        targetPoint?.poids ??
        targetPoint?.nombre ??
        null;
      if (extractedValue) {
        value = extractedValue;
        foundValue = true;
        console.log(
          "Found appointment-specific value in points for",
          property.nom,
          ":",
          value,
        );
      }
    }

    // Try 2: Get value from chart details - use helper function with appointmentId
    if (!foundValue) {
      const details = appointmentChartDetails[appointmentId] ?? {};
      if (details[property.id]) {
        const extractedValue = getValueFromChartDetail(
          details[property.id],
          appointmentId,
        );
        if (extractedValue != null) {
          value = extractedValue;
          foundValue = true;
          console.log(
            "Found value in chart details for",
            property.nom,
            ":",
            value,
          );
        }
      }
    }

    // Try 3: Get value from weights map - uses appointment-specific groups
    if (!foundValue) {
      const latestVal = getLatestFromMap(property, appointmentId);
      if (latestVal && latestVal?.value) {
        value =
          latestVal.value ?? latestVal.valeur ?? latestVal.poids ?? latestVal;
        foundValue = true;
        console.log(
          "Found appointment-scoped value in weights map for",
          property.nom,
          ":",
          value,
        );
      }
    }

    return { value, foundValue };
  };

  const saveMedicalButton = () => {
    toggleAddMedicalBackground();
    setinputValue("");

    // Find the index of the item with the matching id
    const index = DataObj.findIndex((item) => item.id === selectedId);

    if (index !== -1) {
      // Ensure the item was found
      // Assuming there is an array property in DataObj[index] to push to
      if (!DataObj[index].values) {
        DataObj[index].values = []; // Initialize the array if it doesn't exist
      }
      DataObj[index].values.push(inputValue); // Push the inputValue to the array
    }
  };

  const [inputValue, setinputValue] = useState();

  const medicalBackgroundInput = (value) => {
    setinputValue(value);
  };

  const removeItem = (itemId, value) => {
    const updatedDataObj = DataObj.map((item) => {
      if (item.id === itemId) {
        const updatedValues = item.values.filter((val) => val !== value); //filter array method

        // Set values to an empty array if the last item is removed
        return {
          ...item, //Spread operator
          values: updatedValues.length > 0 ? updatedValues : [],
        };
      }
      return item;
    });

    setDataObj(updatedDataObj); // Update state with the filtered data
  };

  const [showPatientDocument, setShowPatientDocument] = useState(false);

  const togglePatientDocument = () => {
    setShowPatientDocument(!showPatientDocument);
  };

  const [showCancelAppointmnet, setShowCancelAppointmnet] = useState(false);

  const toggleCancelAppointmnet = () => {
    setShowCancelAppointmnet(!showCancelAppointmnet);
  };

  const [showReferDoctorModal, setShowReferDoctorModal] = useState(false);

  const [showToDoctorModal, setShowToDoctorModal] = useState(false);

  const [addNotePopupOpen, setAddNotePopupOpen] = useState(false);

  const getDateAvailabilityList = async (docId, date, consultationType) => {
    if (docId && date && consultationType) {
      try {
        setSkelLoading(true);
        let formData = new FormData();
        formData.append("doctor_id", docId);
        formData.append("date", date);
        formData.append("consultation_types", consultationType);

        let response = await dateAvailabilityApi(formData);
        if (response) {
          if (response.data.res === true) {
            // const notAvailableSet = new Set(response.data.notAvailable.map(({time}) => time));
            // const tempArray = response.data.data.filter(item => !notAvailableSet.has(item));
            const tempFormatHoliday = response.data.holiday
              ? response.data.holiday.map((item) => item.holiday_date)
              : [];
            if (tempFormatHoliday.includes(date)) {
              setAvailDates([]);
            } else {
              setAvailDates(response.data.data);
            }
            setBookedAppoinment(
              response.data.notAvailable.map(({ time }) => time),
            );
            const tempFutureDate = moment().add(
              parseInt(response.data.future_days, 10),
              "days",
            );
            setFutureDate(tempFutureDate);
            setSelectedTime(null);
            setRescheduleReason(null);
          } else {
            toast.error(response.data.msg, { autoClose: 1500 });
          }
        }
        setSkelLoading(false);
      } catch (error) {
        setSkelLoading(false);
        console.error(error);
        toast.error("Something went wrong in server. Please try again.", {
          autoClose: 1500,
        });
      }
    }
  };

  const calculateAge = (dob) => {
    const birthDate = new Date(dob);
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();

    // Adjust age if the birthday has not occurred yet this year
    if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age;
  };

  const getPatientDictionaryDetails = async () => {
    try {
      setScreenLoading(true);
      const fd = new FormData();
      fd.append("id", childId ? childId : patientId);

      let response = await getPatientDictionaryDetailsApi(fd);
      if (response) {
        if (response.data.res === true) {
          setAllPatientDetails(response.data);
          setGlobalNote(response.data?.global_note[0]?.notes);
          setPrevGlobalNote(response.data?.global_note[0]?.notes);
        } else {
          toast.error(response.data.msg, { autoClose: 1500 });
        }
      }
      setScreenLoading(false);
    } catch (error) {
      toast.error("Something went wrong in server. Please try again.", {
        autoClose: 1500,
      });
      setScreenLoading(false);
      console.error(error);
    }
  };

  const getPatientChildDictionaryDetails = async (childId) => {
    try {
      setScreenLoading(true);
      const fd = new FormData();
      fd.append("id", childId ? childId : patientId);

      let response = await getPatientDictionaryDetailsApi(fd);
      if (response) {
        if (response.data.res === true) {
          setAllPatientChildDetails(response.data);
          setGlobalNote(response.data?.global_note[0]?.notes);
          setPrevGlobalNote(response.data?.global_note[0]?.notes);
        } else {
          toast.error(response.data.msg, { autoClose: 1500 });
        }
      }
      setScreenLoading(false);
    } catch (error) {
      toast.error("Something went wrong in server. Please try again.", {
        autoClose: 1500,
      });
      setScreenLoading(false);
      console.error(error);
    }
  };

  const getPatientFamilyList = async (childId) => {
    try {
      setScreenLoading(true);
      const fd = new FormData();
      fd.append("patient_id", childId ? childId : patientId);

      let response = await patientFamilyListApi(fd);
      if (response) {
        if (response.data.res === true) {
          setPatientFamilyList(response.data.data);
        } else {
          toast.error(response.data.msg, { autoClose: 1500 });
        }
      }
      setScreenLoading(false);
    } catch (error) {
      setScreenLoading(false);
      console.error(error);
      toast.error("Something went wrong in server. Please try again.", {
        autoClose: 1500,
      });
    }
  };

  const getDoctorForSearch = async (value) => {
    try {
      setToDoctorSearchLoader(true);
      const fd = new FormData();
      fd.append("search", value);

      let response = await getDoctorForSearchApi(fd);
      if (response) {
        if (response.data.res === true) {
          if (response.data.doctors.length > 0) {
            setToDoctorSearchList(response.data.doctors);
          } else {
            setToDoctorSearchList([]);
          }
        } else {
          toast.error(response.data.msg, { autoClose: 1500 });
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong in server. Please try again.", {
        autoClose: 1500,
      });
    } finally {
      setToDoctorSearchLoader(false);
    }
  };

  const handleSelectMessageSender = (type, selectedItem) => {
    let tempObj = { ...messageSenderObj };
    if (type === "to-doctor") {
      tempObj.type = type;
      selectedItem.id = selectedItem.user_id;
      tempObj.selectedItem = selectedItem;
    } else if (type === "to-patient") {
      tempObj.type = type;
      tempObj.selectedItem = {
        id: appointmentDetails?.patient_details[0]?.id,
        first_name: appointmentDetails?.patient_details[0]?.first_name,
        last_name: appointmentDetails?.patient_details[0]?.last_name,
      };
    } else if (type === "refer-to") {
      tempObj.type = type;
      if (!selectedItem) {
        tempObj.docNotAvailable = true;
        tempObj.selectedItem = {
          id: "",
          first_name: toDoctorSearchText,
          last_name: "",
        };
      } else {
        selectedItem.id = selectedItem.user_id;
        tempObj.selectedItem = selectedItem;
      }
    }
    setShowToDoctorModal(false);
    setShowReferDoctorModal(false);
    setMessageSenderObj(tempObj);
  };

  const handleReadMesssage = async (patientId) => {
    try {
      const fd = new FormData();
      fd.append("from_id", patientId);
      fd.append("read_type", "doctor");
      let response = await readDoctorMessageApi(fd);
      if (response) {
        if (response.data.res === true) {
          let tempAppDetails = { ...appointmentDetails };
          tempAppDetails.patient_read_count = 0;
          setAppointmentDetails(tempAppDetails);
        } else {
          toast.error(
            response.data.msg ||
            "Something went wrong in server. Please try again.",
            { autoClose: 1500 },
          );
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong in server. Please try again.", {
        autoClose: 1500,
      });
    } finally {
    }
  };

  const getMedicineDetailsList = async (value) => {
    try {
      setMedicineSearchLoad(true);
      let formData = new FormData();
      formData.append("search", value ? value : "");
      let response = await searchMedicinesDetailsApi(formData);
      if (response) {
        if (response.data.res === true) {
          setSearchMedicineList(response.data.list);
        } else {
          toast.error(response.data.msg, { autoClose: 1500 });
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong in server. Please try again.", {
        autoClose: 1500,
      });
    } finally {
      setMedicineSearchLoad(false);
    }
  };

  const getTestDetailsList = async (value) => {
    try {
      setTestSearchLoad(true);
      let formData = new FormData();
      formData.append("search", value ? value : "");
      let response = await searchMedicalTestApi(formData);
      if (response) {
        if (response.data.res === true) {
          setSearchTestList(response.data.list);
        } else {
          toast.error(response.data.msg, { autoClose: 1500 });
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong in server. Please try again.", {
        autoClose: 1500,
      });
    } finally {
      setTestSearchLoad(false);
    }
  };

  const handleResetAll = () => {
    setPrescriptionContent("");
    setSearchMedicineTerm("");
    setSearchTestTerm("");
    setSelectedMedicineObject({});
    setSelectedTemplateEdit(null);
  };

  const handleChangeGlobalNote = async (value) => {
    if (value !== prevGlobalNote) {
      try {
        const fd = new FormData();
        fd.append(
          "patient_id",
          childId ? childId : allPatientDetails?.data[0]?.id,
        );
        fd.append("notes", value);
        let response = await createGlobalNoteApi(fd);
        if (response) {
          if (response.data.res === true) {
            setPrevGlobalNote(value);
          } else {
            toast.error(
              response.data.msg
                ? response.data.msg
                : "Something went wrong in server. Please try again.",
              { autoClose: 1500 },
            );
          }
        }
      } catch (error) {
        console.error(error);
        toast.error("Something went wrong in server. Please try again.", {
          autoClose: 1500,
        });
      } finally {
      }
    }
  };

  const handleCreateDictionaryNote = async () => {
    if (!selectedAppForNote) {
      toast.warning("Appointment is not available.");
    } else if (!appForNoteText) {
      toast.warning("Please enter note.");
    } else {
      try {
        setPopupBtnDis(true);
        const fd = new FormData();
        fd.append("appointment_id", selectedAppForNote?.id);
        fd.append("patient_id", allPatientDetails?.data[0]?.id);
        fd.append("notes", appForNoteText);
        let response = await createDictionaryNoteApi(fd);
        if (response) {
          if (response.data.res === true) {
            // expand the appointment by id so UI remains stable after updates
            setExpandAppointmentId(selectedAppForNote?.id ?? null);
            let tempPatDet = { ...allPatientDetails };
            let tmpSelApp = tempPatDet.Appointment.find(
              (item) => parseInt(item?.id) === parseInt(selectedAppForNote?.id),
            );
            tmpSelApp?.dictionary_notes?.push(response.data.data);
            setAllPatientDetails(tempPatDet);
            setSelectedAppForNote(null);
            setAppForNoteText("");
            setAddNotePopupOpen(false);
            toast.success(response.data.msg || "Added Successfully.", {
              autoClose: 1500,
            });
          } else {
            toast.error(
              response.data.msg
                ? response.data.msg
                : "Something went wrong in server. Please try again.",
              { autoClose: 1500 },
            );
          }
        }
      } catch (error) {
        console.error(error);
        toast.error("Something went wrong in server. Please try again.", {
          autoClose: 1500,
        });
      } finally {
        setPopupBtnDis(false);
      }
    }
  };

  const handleChangePriority = async (value) => {
    try {
      setScreenLoading1(true);
      const fd = new FormData();
      fd.append("id", "");
      fd.append("patient_id", childId ? childId : patientId);
      fd.append("type", "priority");
      fd.append("value", value);
      let response = await updatePriorityApi(fd);
      if (response) {
        if (response.data.res === true) {
          if (childId) {
            let tempObj = { ...allPatientChildDetails };
            tempObj.data[0].priority = value;
            setAllPatientChildDetails(tempObj);
          } else {
            let tempObj = { ...allPatientDetails };
            tempObj.data[0].priority = value;
            setAllPatientDetails(tempObj);
          }
          toast.success(
            response.data.msg ? response.data.msg : "Updated successfully.",
            { autoClose: 1500 },
          );
        } else {
          toast.error(response.data.msg, { autoClose: 1500 });
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong in server. Please try again.", {
        autoClose: 1500,
      });
    } finally {
      setScreenLoading1(false);
    }
  };

  const handleSaveAddress = async () => {
    try {
      setScreenLoading1(true);
      const fd = new FormData();
      fd.append("patient_id", childId ? childId : patientId);
      fd.append("patient_address", editedAddress);

      let response = await updatePatientFromDoctorByPatientIdApi(fd);
      if (response && response.data.res === true) {
        if (childId) {
          let tempObj = { ...allPatientChildDetails };
          tempObj.data[0].patient_address = editedAddress;
          setAllPatientChildDetails(tempObj);
        } else {
          let tempObj = { ...allPatientDetails };
          tempObj.data[0].patient_address = editedAddress;
          setAllPatientDetails(tempObj);
        }
        toast.success(
          response.data.msg
            ? response.data.msg
            : "Address updated successfully.",
          { autoClose: 1500 },
        );
        setIsEditingAddress(false);
      } else {
        toast.error(response?.data?.msg || "Failed to update address", {
          autoClose: 1500,
        });
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong. Please try again.", {
        autoClose: 1500,
      });
    } finally {
      setScreenLoading1(false);
    }
  };

  const handleSavePhone = async () => {
    const nextPhone = String(editedPhone || "").trim();

    if (!nextPhone) {
      toast.warning("Please enter new phone number.", { autoClose: 1500 });
      return;
    }

    if (!/^\d{5,10}$/.test(nextPhone)) {
      toast.warning("New phone number is not valid.", { autoClose: 1500 });
      return;
    }

    try {
      setScreenLoading1(true);
      const fd = new FormData();
      fd.append("patient_id", childId ? childId : patientId);
      fd.append("cell_phone", nextPhone);

      const response = await doctorEditPhoneNumberApi(fd);
      if (response && response.data.res === true) {
        if (childId) {
          const tempObj = { ...allPatientChildDetails };
          tempObj.data[0].cell_phone = nextPhone;
          setAllPatientChildDetails(tempObj);
        } else {
          const tempObj = { ...allPatientDetails };
          tempObj.data[0].cell_phone = nextPhone;
          setAllPatientDetails(tempObj);
        }
        if (allAppDetails?.data?.[0]?.patient_details?.[0]) {
          const nextAppDetails = { ...allAppDetails };
          nextAppDetails.data[0].patient_details[0].cell_phone = nextPhone;
          setAllAppDetails(nextAppDetails);
        }
        toast.success(
          response.data.msg ? response.data.msg : "Number edited successfully.",
          { autoClose: 1500 },
        );
        setIsEditingPhone(false);
      } else {
        toast.error(response?.data?.msg || "Failed to update phone number", {
          autoClose: 1500,
        });
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong. Please try again.", {
        autoClose: 1500,
      });
    } finally {
      setScreenLoading1(false);
    }
  };

  const handleChangePrioritySupport = async (value) => {
    try {
      setScreenLoading1(true);
      const fd = new FormData();
      fd.append("id", "");
      fd.append("patient_id", childId ? childId : patientId);
      fd.append("type", "supports");
      fd.append("value", value);
      let response = await updatePriorityApi(fd);
      if (response) {
        if (response.data.res === true) {
          let tempObj = { ...allPatientDetails };
          tempObj.data[0].support = value;
          setAllPatientDetails(tempObj);
          toast.success(
            response.data.msg ? response.data.msg : "Updated successfully.",
            { autoClose: 1500 },
          );
        } else {
          toast.error(response.data.msg, { autoClose: 1500 });
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong in server. Please try again.", {
        autoClose: 1500,
      });
    } finally {
      setScreenLoading1(false);
    }
  };

  const { data: cities } = useCities()

  const getCityList = async () => {
    try {
      if (cities) {
        setCityList(cities);
      } else {
        throw new Error("Error fetching cities because response is : ", cities);
      }
    } catch (error) {
      toast.error(error.message, { autoClose: 1500 });
    }
  };

  const handleAddKid = async () => {
    if (!addPatientObject?.gender) {
      toast.warning("Please select gender.", { autoClose: 1500 });
    } else if (!addPatientObject?.firstName) {
      toast.warning("Please enter first name.", { autoClose: 1500 });
    } else if (/[\u0600-\u06FF]/.test(addPatientObject.firstName)) {
      toast.warning("First name cannot contain Arabic characters.", {
        autoClose: 1500,
      });
    } else if (!addPatientObject?.lastName) {
      toast.warning("Please enter last name.", { autoClose: 1500 });
    } else if (/[\u0600-\u06FF]/.test(addPatientObject.lastName)) {
      toast.warning("Last name cannot contain Arabic characters.", {
        autoClose: 1500,
      });
    } else if (!addPatientObject?.month) {
      toast.warning("Please select month.", { autoClose: 1500 });
    } else if (!addPatientObject?.day) {
      toast.warning("Please select day.", { autoClose: 1500 });
    } else if (!addPatientObject?.year) {
      toast.warning("Please select year.", { autoClose: 1500 });
    } else if (!addPatientObject?.birthCity) {
      toast.warning("Please select birth city.", { autoClose: 1500 });
    } else if (!addPatientObject?.relation) {
      toast.warning("Please select relation.", { autoClose: 1500 });
    } else {
      setPopupBtnDis(true);
      try {
        let formData = new FormData();
        formData.append("gender", addPatientObject.gender);
        formData.append("first_name", addPatientObject.firstName);
        formData.append("last_name", addPatientObject.lastName);
        formData.append("relation", addPatientObject.relation);
        formData.append("month", addPatientObject.month);
        formData.append("day", addPatientObject.day);
        formData.append("year", addPatientObject.year);
        formData.append("birth_city_id", addPatientObject.birthCity);
        formData.append("parent_id", patientId);

        let response = await doctorAddPatientMemberApi(formData);
        if (response) {
          if (response.data.res === true) {
            setShowProfileModal(false);
            setAddPatientObject({});
            getPatientDictionaryDetails();
            toast.success(
              response.data.msg ? response.data.msg : "Added successfully.",
              { autoClose: 1500 },
            );
          } else {
            toast.error(response.data.msg, { autoClose: 1500 });
          }
        }
        setPopupBtnDis(false);
      } catch (error) {
        setPopupBtnDis(false);
        console.error(error);
        toast.error("Something went wrong in server. Please try again.", {
          autoClose: 1500,
        });
      }
    }
  };

  const handleChangePhoneNumber = async () => {
    if (!newPhoneNumber) {
      toast.warning("Please enter new phone number.", { autoClose: 1500 });
    } else if (newPhoneNumber && !/^\d{5,10}$/.test(newPhoneNumber)) {
      toast.warning("New phone number is not valid.", { autoClose: 1500 });
    } else {
      setPopupBtnDis(true);
      try {
        let formData = new FormData();
        formData.append("cell_phone", newPhoneNumber);
        formData.append("patient_id", childId ? childId : patientId);

        let response = await doctorEditPhoneNumberApi(formData);
        if (response) {
          if (response.data.res === true) {
            setShowChangePhoneModal(false);
            setNewPhoneNumber("");
            getPatientDictionaryDetails();
            toast.success(
              response.data.msg
                ? response.data.msg
                : "Number edited successfully.",
              { autoClose: 1500 },
            );
          } else {
            toast.error(response.data.msg, { autoClose: 1500 });
          }
        }
        setPopupBtnDis(false);
      } catch (error) {
        setPopupBtnDis(false);
        console.error(error);
        toast.error("Something went wrong in server. Please try again.", {
          autoClose: 1500,
        });
      }
    }
  };

  const validateAddAppointmentForm = (type) => {
    let isValid = true;

    if (type === "without-tracking") {
      if (!addAppObject?.patientFirstName) {
        toast.warning(`Please enter patient first name.`, { autoClose: 1500 });
        isValid = false;
      } else if (/[\u0600-\u06FF]/.test(addAppObject.patientFirstName)) {
        toast.warning(`First name cannot contain Arabic characters.`, {
          autoClose: 1500,
        });
        isValid = false;
      } else if (!addAppObject?.patientLastName) {
        toast.warning(`Please enter patient last name.`, { autoClose: 1500 });
        isValid = false;
      } else if (/[\u0600-\u06FF]/.test(addAppObject.patientLastName)) {
        toast.warning(`Last name cannot contain Arabic characters.`, {
          autoClose: 1500,
        });
        isValid = false;
      }
    } else {
      if (!addAppObject?.patientFirstName) {
        toast.warning(`Please enter patient first name.`, { autoClose: 1500 });
        isValid = false;
      } else if (/[\u0600-\u06FF]/.test(addAppObject.patientFirstName)) {
        toast.warning(`First name cannot contain Arabic characters.`, {
          autoClose: 1500,
        });
        isValid = false;
      } else if (!addAppObject?.patientLastName) {
        toast.warning(`Please enter patient last name.`, { autoClose: 1500 });
        isValid = false;
      } else if (/[\u0600-\u06FF]/.test(addAppObject.patientLastName)) {
        toast.warning(`Last name cannot contain Arabic characters.`, {
          autoClose: 1500,
        });
        isValid = false;
      } else if (!addAppObject?.patientGender) {
        toast.warning(`Please select patient gender.`, { autoClose: 1500 });
        isValid = false;
      } else if (!addAppObject?.patientCity) {
        toast.warning(`Please select city.`, { autoClose: 1500 });
        isValid = false;
      } else if (!addAppObject?.patientMonth) {
        toast.warning(`Please select DOB month.`, { autoClose: 1500 });
      } else if (!addAppObject?.patientDay) {
        isValid = false;
        toast.warning(`Please select DOB day.`, { autoClose: 1500 });
        isValid = false;
      } else if (!addAppObject?.patientYear) {
        toast.warning(`Please select DOB year.`, { autoClose: 1500 });
        isValid = false;
      } else if (!addAppObject?.patientNumber) {
        toast.warning(`Please enter phone number.`, { autoClose: 1500 });
        isValid = false;
      } else if (
        addAppObject?.patientNumber &&
        !/^\d{5,10}$/.test(addAppObject?.patientNumber)
      ) {
        toast.warning(`Phone number is not valid.`, { autoClose: 1500 });
        isValid = false;
      } else if (!addAppObject?.idNumber) {
        toast.warning(`Please enter ID number.`, { autoClose: 1500 });
        isValid = false;
      } else if (
        addAppObject?.idNumber &&
        !/^\d{9}$/.test(addAppObject?.idNumber)
      ) {
        toast.warning(`Invalid Id Number. It must be exactly 9 digits.`, {
          autoClose: 1500,
        });
        isValid = false;
      } else if (!addAppObject?.birthCity) {
        toast.warning(`Please select birth city.`, { autoClose: 1500 });
        isValid = false;
      }
    }

    return isValid;
  };

  const handleAddAppointmentFromPopup = (type, oldPatientDetails) => {
    if (validateAddAppointmentForm(type)) {
      addAppObject.date = new Date();
      addAppObject.appTime = moment().format("HH:mm");
      addAppObject.oldPatientDetails = oldPatientDetails;
      if (type) {
        addAppObject.appointmentType = type;
      }
      if (startUnschedulePopupOpen) {
        addAppObject.isUnschedule = true;
      }
      handleAddAppointment(addAppObject);
    }
  };

  const handleSchedule = (oldPatientDetails) => {
    addAppObject.date = new Date(calendarValue);
    addAppObject.appTime = selectedTime;
    addAppObject.oldPatientDetails = oldPatientDetails;
    if (startUnschedulePopupOpen) {
      addAppObject.isUnschedule = true;
    }
    handleAddAppointment(addAppObject);
  };

  const handleAddAppointment = (addAppObject) => {
    sessionStorage.setItem(
      "doctolikAddAppObjByDoc",
      JSON.stringify(addAppObject),
    );
    navigate(`/doctor/appointment-booking`, {
      state: { fromUrl: location.pathname },
    });
  };

  const handleDateClick = async (date) => {
    const newDate = date.toDateString();
    setCalendarValue(date);
    getDateAvailabilityList(
      userData?.users?.id,
      format(date, "yyyy-MM-dd"),
      "For online consultation",
    );
  };

  const tileClassName = ({ date }) => {
    const formattedDate = date.toDateString();
    return calendarValue === formattedDate ? "highlighted-date" : null;
  };

  const getHolidays = async (date) => {
    if (date) {
      try {
        let formData = new FormData();
        formData.append("day", date);

        let response = await fetchHolidayApi(formData);
        if (response) {
          if (response.data.res === true) {
            const formattedDates = response.data.data.map((item) =>
              new Date(item.holiday_date).toDateString(),
            );
            setSelectedDates(formattedDates);
          } else {
            toast.error(response.data.msg, { autoClose: 1500 });
          }
        }
      } catch (error) {
        console.error(error);
        toast.error("Something went wrong in server. Please try again.", {
          autoClose: 1500,
        });
      }
    }
  };

  const getRescheduleReason = async () => {
    try {
      let response = await getRescheduleReasonApi();
      if (response) {
        if (response.data.res === true) {
          setRescheduleReasonList(response.data.data);
        } else {
          toast.error(response.data.msg, { autoClose: 1500 });
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong in server. Please try again.", {
        autoClose: 1500,
      });
    }
  };

  const handleActiveStartDateChange = ({ action, activeStartDate, view }) => {
    if (action === "prev" || action === "next") {
      const formattedDate = format(activeStartDate, "yyyy-MM");
      getHolidays(formattedDate);
    }
  };

  const generateTimeSlots = (startTime, endTime, interval, timeSlotType) => {
    const slots = [];

    // Create moment objects for the start and end times
    const startMoment = moment(startTime, "HH:mm");
    const endMoment = moment(endTime, "HH:mm");

    // Loop to generate time slots
    while (startMoment.isBefore(endMoment)) {
      slots.push(startMoment.format("HH:mm")); // Format as HH:mm
      if (timeSlotType === "Minute") {
        startMoment.add(interval, "minutes"); // Increment by the interval in minutes
      } else if (timeSlotType === "Hour") {
        startMoment.add(interval, "hours"); // Increment by the interval in hours
      }
    }

    // Remove the last slot if it equals the end time
    if (slots[slots.length - 1] === endMoment.format("HH:mm")) {
      slots.pop();
    }
    return slots;
  };

  const handleSelectTime = (time) => {
    if (time.has_interval === 1) {
      let title = time?.start_time + "-" + time?.end_time;
      let count = 0;
      bookedAppoinment.forEach((element) => {
        if (element === title) {
          count += 1;
        }
      });

      if (count >= time?.visitor) {
        toast.warning(
          "Oops! This time slot is full. Please try on different time.",
          { autoClose: 1500 },
        );
        setSelectedTime(null);
      } else {
        setSelectedTime(title);
      }
    } else {
      if (bookedAppoinment.includes(time)) {
        toast.warning(
          "Oops! This time slot is already taken. Please choose a different slot.",
          { autoClose: 1500 },
        );
        setSelectedTime(null);
      } else {
        setSelectedTime(time);
      }
    }
  };

  useEffect(() => {
    getPatientDictionaryDetails();
    getPatientFamilyList();
    getCityList();
  }, [patientId]);

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const childId = query.get("child");
    setChildId(childId);
    getPatientChildDictionaryDetails(childId);
    // getPatientFamilyList(childId);
  }, [location.search]);

  // Helper: merge prescription data from both the initial API response and async-loaded data,
  // so prescriptor prescriptions (which are only in item?.prescription_content) are not lost.
  const getMergedPrescriptions = (apptItem) => {
    const apiPrescriptions = apptItem?.prescription_content || [];
    const loadedPrescriptions = appointmentPrescriptionContent[apptItem?.id];
    if (loadedPrescriptions === undefined) {
      // Not yet async-loaded; use the full API data
      return apiPrescriptions;
    }
    // Merge: start from apiPrescriptions, then add any loaded ones not already present
    const seen = new Set(
      apiPrescriptions.map((p) => String(p.id ?? JSON.stringify(p))),
    );
    const extra = (loadedPrescriptions || []).filter((p) => {
      const k = String(p.id ?? JSON.stringify(p));
      return !seen.has(k);
    });
    return [...apiPrescriptions, ...extra];
  };

  return (
    <div className="doctormain">
      <Sidebar />
      <div className="rightSec">
        <DashboardDoctorHeader />

        {screenLoading && <LoadingPage />}
        {screenLoading1 && <LoadingPage />}
        <div className="RoxBox chimouch">
          <div className="RghtDoctorConsultationObservations chw">
            <div className="RghtDoctorConsultationObservationsTop">
              {allAppDetails?.previousId || allAppDetails?.nextId ? (
                <div className="NextAppHolder">
                  {allAppDetails?.previousId ? (
                    <Tooltip title={`Previous appointment`} placement="top">
                      <img
                        src={leftArrowImg}
                        className="ArrowIcon"
                        onClick={() =>
                          navigate(
                            `/doctor/appointment-details/${allAppDetails?.previousId}`,
                          )
                        }
                      />
                    </Tooltip>
                  ) : null}

                  <h4>
                    Date -{" "}
                    {moment(appointmentDetails?.appointment_date).format(
                      "ddd D, YYYY",
                    )}
                    , Time - {appointmentDetails?.time}
                  </h4>
                  {allAppDetails?.nextId ? (
                    <Tooltip title={`Next appointment`} placement="top">
                      <img
                        src={rightArrowImg}
                        className="ArrowIcon"
                        onClick={() =>
                          navigate(
                            `/doctor/appointment-details/${allAppDetails?.nextId}`,
                          )
                        }
                      />
                    </Tooltip>
                  ) : null}
                </div>
              ) : null}
            </div>
          </div>
        </div>
        {!screenLoading ? (
          <div className="RoxBox patientDictionaryRoxBox">
            <div className="LftDoctorConsultationObservations">
              <PatientDetailsCard
                allPatientDetails={allPatientDetails}
                childId={childId}
                patientId={patientId}
                showKidsRef={showKidsRef}
                showAddKidsSection={showAddKidsSection}
                toggleProfileMoadl={toggleProfileMoadl}
                navigate={navigate}
                setShowAddKidsSection={setShowAddKidsSection}
                setEditedPhone={setEditedPhone}
                setIsEditingPhone={setIsEditingPhone}
                setStartUnschedulePopupOpen={setStartUnschedulePopupOpen}
                setReschedulePopupShow={setReschedulePopupShow}
                getDateAvailabilityList={getDateAvailabilityList}
                userData={userData}
                calendarValue={calendarValue}
                allPatientChildDetails={allPatientChildDetails}
                isEditingPhone={isEditingPhone}
                editedPhone={editedPhone}
                handleSavePhone={handleSavePhone}
                DOC_doctorId={DOC_doctorId}
                isEditingAddress={isEditingAddress}
                editedAddress={editedAddress}
                setEditedAddress={setEditedAddress}
                handleSaveAddress={handleSaveAddress}
                setIsEditingAddress={setIsEditingAddress}
                handleChangePriority={handleChangePriority}
                handleChangePrioritySupport={handleChangePrioritySupport}
                patientFamilyList={patientFamilyList}
              />
              <div className="Accordion">
                <ChatWithPatientCard
                  activeIndexes={activeIndexes}
                  toggleAccordion={toggleAccordion}
                  patientId={
                    childId
                      ? allPatientChildDetails?.data?.[0]?.id
                      : allPatientDetails?.data?.[0]?.id
                  }
                  DOC_doctorId={DOC_doctorId}
                  userData={userData}
                  onMessageSent={() => setMessageSenderObj(null)}
                />
                <ChatWithDoctorCard
                  activeIndexes={activeIndexes}
                  toggleAccordion={toggleAccordion}
                  patientId={
                    childId
                      ? allPatientChildDetails?.data?.[0]?.id
                      : allPatientDetails?.data?.[0]?.id
                  }
                  DOC_doctorId={DOC_doctorId}
                  userData={userData}
                />
              </div>
            </div>
            <div
              className="RghtDoctorConsultationObservations chw"
              style={{ marginLeft: 20 }}
            >
              <GlobalNotesList
                setGlobalNote={setGlobalNote}
                globalNote={globalNote}
                handleChangeGlobalNote={handleChangeGlobalNote}
              />

              {/* Quick Payment Management Card */}
              <div style={{ marginBottom: "15px" }}>
                <button
                  onClick={() => setShowPaymentSection(!showPaymentSection)}
                  style={{
                    background: "#4a90e2",
                    color: "white",
                    border: "none",
                    padding: "10px 20px",
                    borderRadius: "5px",
                    cursor: "pointer",
                    fontSize: "14px",
                    fontWeight: "500",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => (e.target.style.background = "#357abd")}
                  onMouseLeave={(e) => (e.target.style.background = "#4a90e2")}
                >
                  {showPaymentSection
                    ? "− Hide Payment Management"
                    : "+ Show Payment Management"}
                </button>
              </div>
              {showPaymentSection && (
                <PaymentQuickAccess
                  patientId={patientId}
                  childId={childId}
                  allPatientDetails={allPatientDetails}
                  allPatientChildDetails={allPatientChildDetails}
                  onPaymentUpdate={() => getPatientDictionaryDetails()}
                />
              )}

              <section className="improvedAppointmentExamples" aria-labelledby="improved-appointments-title">
                <div className="improvedAppointmentExamplesHeader">
                  <div>
                    <span>New card preview</span>
                    <h2 id="improved-appointments-title">Appointments</h2>
                  </div>
                  <small>Open a card to load its clinical details</small>
                </div>
                <AppointmentList
                  initialItems={appointmentCardItems}
                  loadSection={loadAppointmentCardSection}
                  size={10}
                />
              </section>
            </div>
          </div>
        ) : null}
        {addNotePopupOpen && (
          <div className="popup holidayPopup AddANoteModal">
            <div className="popup-content">
              <button
                onClick={() => setAddNotePopupOpen(false)}
                className="cancelBtn"
              >
                <img src={cancelIcon} alt="" />
              </button>
              <div className="addNursePopup">
                <h2 className="nurseHdn">Add Note</h2>
                <ul className="addNoteList">
                  <li>
                    <textarea
                      placeholder="Add Note"
                      className="textarea-control"
                      value={appForNoteText}
                      onChange={(e) => setAppForNoteText(e.target.value)}
                    ></textarea>
                  </li>
                  <li>
                    <button
                      disabled={popupBtnDis}
                      onClick={() => handleCreateDictionaryNote()}
                    >
                      {popupBtnDis ? "Please wait..." : "Submit"}
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        )}
        {showMedicalReport && (
          <div
            className="modal MedicalReportModal"
            onClick={toggleMedicalReport}
          >
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <button
                  className="CloseButton"
                  onClick={toggleMedicalReport}
                ></button>
                <h3>{selectedPresPopup?.template_name}</h3>
              </div>
              <div className="modal-body">
                {selectedPresPopup ? (
                  <div className="MedicalReportBox">
                    {/* <h4>Prescription</h4> */}
                    <ul className="NumList2">
                      <li style={{ marginBottom: "12px" }}>
                        <MedicineParserDisplay
                          text={buildPrescriptionDisplayText(
                            selectedPresPopup,
                            dictionaryPatientProfile,
                          )}
                          profile={dictionaryPatientProfile}
                          detailedPrescription={selectedPresPopup}
                        />
                      </li>
                    </ul>
                  </div>
                ) : null}
                {/* Protocole de soin (care steps) - affichage simple (filtered by date when available) */}
                {Array.isArray(careSteps) && careSteps.length > 0 ? (
                  <div className="MedicalReportBox">
                    <h4>Protocole de soin</h4>
                    <ul className="NumList2">
                      {(() => {
                        const sorted = [...careSteps].sort(
                          (a, b) =>
                            new Date(a.created_at) - new Date(b.created_at),
                        );
                        const filtered = targetDateNorm
                          ? sorted.filter((s) => {
                            const sDate =
                              s?.created_at ??
                              s?.createdAt ??
                              s?.date ??
                              null;
                            return sDate
                              ? moment(sDate).format("YYYY-MM-DD") ===
                              targetDateNorm
                              : false;
                          })
                          : sorted;
                        return filtered.map((step) => (
                          <li key={step.id || step.created_at}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "baseline",
                                gap: 8,
                              }}
                            >
                              <strong>
                                {step.label ||
                                  step.nom ||
                                  step.name ||
                                  "Untitled"}
                              </strong>
                              {step.created_at ? (
                                <span className="small">
                                  {" "}
                                  —{" "}
                                  {moment(step.created_at).format("D MMM YYYY")}
                                </span>
                              ) : null}
                            </div>
                            {step.comment ? (
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: step.comment,
                                }}
                              />
                            ) : step.description ? (
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: step.description,
                                }}
                              />
                            ) : null}
                          </li>
                        ));
                      })()}
                    </ul>
                  </div>
                ) : null}

                {/* Charts Section - affiche les propriétés avec tous les points historiques */}
                {(() => {
                  // Skip charts when feature flag is disabled
                  if (!SHOW_CHARTS) return null;
                  // Utilise les états qui sont déjà définis au niveau supérieur
                  if (!Array.isArray(properties) || properties.length === 0) {
                    return null;
                  }

                  return (
                    <div className="MedicalReportBox">
                      <h4>Charts</h4>
                      <ul className="NumList2">
                        {properties.map((p) => {
                          let raw =
                            chartDetails[p.id]?.raw ?? p?.raw ?? p ?? {};
                          if (
                            raw &&
                            typeof raw === "object" &&
                            raw.raw &&
                            typeof raw.raw === "object" &&
                            Object.keys(raw.raw).length > 0
                          ) {
                            raw = raw.raw;
                          }

                          const collectPointsFromRaw = (r) => {
                            if (!r || typeof r !== "object") return [];
                            const points =
                              r.points ??
                              r.data ??
                              r.values ??
                              r.mesures ??
                              r.measurements ??
                              r.historique ??
                              null;
                            const arr = [];
                            if (Array.isArray(points) && points.length > 0) {
                              for (const pt of points) {
                                if (pt === null || pt === undefined) continue;
                                if (typeof pt === "object") {
                                  const val =
                                    pt.value ??
                                    pt.valeur ??
                                    pt.val ??
                                    pt.y ??
                                    pt.v ??
                                    null;
                                  const date =
                                    pt.measured_at ??
                                    pt.date ??
                                    pt.event_date ??
                                    pt.created_at ??
                                    null;
                                  if (val !== undefined && val !== null)
                                    arr.push({ value: val, date });
                                } else if (
                                  typeof pt === "number" ||
                                  typeof pt === "string"
                                ) {
                                  arr.push({ value: pt, date: null });
                                }
                              }
                            }

                            const nestedArr =
                              r.last?.points ?? r.dernier?.points ?? null;
                            if (
                              (!Array.isArray(points) || points.length === 0) &&
                              Array.isArray(nestedArr) &&
                              nestedArr.length > 0
                            ) {
                              for (const pt of nestedArr) {
                                if (!pt) continue;
                                const val =
                                  pt.value ??
                                  pt.valeur ??
                                  pt.val ??
                                  pt.y ??
                                  null;
                                const date =
                                  pt.measured_at ??
                                  pt.date ??
                                  pt.event_date ??
                                  null;
                                if (val !== undefined && val !== null)
                                  arr.push({ value: val, date });
                              }
                            }

                            return arr;
                          };

                          let items = collectPointsFromRaw(raw);
                          // if none, try detailed chartDetails raw
                          if (
                            (!items || items.length === 0) &&
                            chartDetails[p.id]?.raw
                          ) {
                            items = collectPointsFromRaw(
                              chartDetails[p.id].raw,
                            );
                          }

                          // Keep a copy of all collected points (before date filtering) for fallback
                          const allCollectedItems = Array.isArray(items)
                            ? [...items]
                            : [];

                          // fallback to latestWeightsGroups
                          if (
                            (!items || items.length === 0) &&
                            latestWeightsGroups &&
                            Object.keys(latestWeightsGroups).length > 0
                          ) {
                            const normFn = (s) =>
                              String(s ?? "")
                                .trim()
                                .toLowerCase();
                            const candidates = [
                              p.nom,
                              p.parametre,
                              p.raw?.parametre,
                              p.raw?.nom,
                            ];
                            for (const c of candidates) {
                              const nk = normFn(c);
                              if (!nk) continue;
                              const grp = latestWeightsGroups[nk];
                              if (Array.isArray(grp) && grp.length > 0) {
                                items = grp.map((it) => ({
                                  value: it.value,
                                  date: it.date,
                                }));
                                break;
                              }
                            }
                          }

                          // If a target date is selected, filter points to that date (same day)
                          if (
                            targetDateNorm &&
                            Array.isArray(items) &&
                            items.length > 0
                          ) {
                            items = items.filter((pt) => {
                              const d =
                                pt?.date ??
                                pt?.measured_at ??
                                pt?.created_at ??
                                pt?.timestamp ??
                                null;
                              return d
                                ? moment(d).format("YYYY-MM-DD") ===
                                targetDateNorm
                                : false;
                            });
                          }

                          // Fallback: if no points found for that date but we did collect other points, show recent ones
                          let usedItemsFallback = false;
                          if (
                            (!Array.isArray(items) || items.length === 0) &&
                            Array.isArray(allCollectedItems) &&
                            allCollectedItems.length > 0
                          ) {
                            items = allCollectedItems.slice(-5).reverse();
                            usedItemsFallback = true;
                          }

                          const hasItems =
                            Array.isArray(items) && items.length > 0;

                          return (
                            <li key={p.id || p.nom}>
                              <strong>{p.nom ?? p.parametre ?? p.id}</strong>
                              {p.raw?.unite ? (
                                <span className="small"> ({p.raw.unite})</span>
                              ) : null}
                              {hasItems ? (
                                <div className="small">
                                  {items.map((item, i) => (
                                    <div
                                      key={item.id || i}
                                      style={{ marginTop: i > 0 ? 4 : 0 }}
                                    >
                                      • {item.value}
                                      {item.date
                                        ? ` (${moment(item.date).format("D MMM YYYY")})`
                                        : ""}
                                      {usedItemsFallback &&
                                        i === items.length - 1 ? (
                                        <span
                                          className="tiny"
                                          style={{
                                            marginLeft: 8,
                                            opacity: 0.8,
                                          }}
                                        >
                                          {" "}
                                          (dernières valeurs)
                                        </span>
                                      ) : null}
                                    </div>
                                  ))}
                                </div>
                              ) : (
                                <div
                                  className="small"
                                  style={{ color: "#999", fontStyle: "italic" }}
                                >
                                  N/A
                                </div>
                              )}
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  );
                })()}
              </div>
            </div>
          </div>
        )}
        {showFamilyPopup && (
          <div className="popup holidayPopup AddANoteModal">
            <div className="popup-content">
              <button
                onClick={() => setShowFamilyPopup(false)}
                className="cancelBtn"
              >
                <img src={cancelIcon} alt="" />
              </button>
              <div className="addNursePopup familyList">
                <h2 className="nurseHdn">Family</h2>
                <ul className="PatientList">
                  {patientFamilyList?.map((item, index) => (
                    <li
                      key={index}
                      onClick={() => {
                        navigate(`/doctor/patient-dictionary/${item?.user_id}`);
                        setShowFamilyPopup(false);
                      }}
                    >
                      <span className="PatientName">
                        <span className="PatientShortName OtherMember">
                          {item?.initials}
                        </span>
                        <span className="NameWrapper">
                          {item?.first_name} {item?.last_name}
                          <span className="OtherMember">{item?.relation}</span>
                        </span>
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        )}
        {showProfileModal && (
          <AddFamilyMemberModal
            show={showProfileModal}
            onClose={() => setShowProfileModal(false)}
            addPatientObject={addPatientObject}
            setAddPatientObject={setAddPatientObject}
            months={months}
            daysarray={daysarray}
            years={years}
            popupBtnDis={popupBtnDis}
            onSubmit={handleAddKid}
          />
        )}
        {showChangePhoneModal && (
          <div className="popup holidayPopup AddAppointmentModal">
            <div className={`popup-content`}>
              <button
                onClick={() => {
                  setShowChangePhoneModal(false);
                }}
                className="cancelBtn"
              >
                <img src={cancelIcon} alt="" />
              </button>
              <div className="addNursePopup addAppointment">
                <h2 className="nurseHdn">Change Phone Number</h2>
                <div className="patientAddBox">
                  <ul className="addPatientList">
                    <li>
                      <label>New Phone Number</label>
                      <input
                        type="number"
                        placeholder="Enter new phone number"
                        value={newPhoneNumber}
                        onChange={(e) => setNewPhoneNumber(e.target.value)}
                      />
                    </li>
                    <li>
                      <button
                        disabled={popupBtnDis}
                        onClick={() => handleChangePhoneNumber()}
                      >
                        {popupBtnDis ? "Please wait..." : "Edit"}
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        )}
        {startUnschedulePopupOpen && (
          <div className="popup holidayPopup AddAppointmentModal">
            <div className={`popup-content`}>
              <button
                onClick={() => {
                  setStartUnschedulePopupOpen(false);
                }}
                className="cancelBtn"
              >
                <img src={cancelIcon} alt="" />
              </button>
              <div className="addNursePopup addAppointment">
                <h2 className="nurseHdn">Schedule Appointment</h2>
                <div className="patientAddBox">
                  <ul className="addPatientList">
                    {/* <li className="halfList"> */}
                    <li>
                      <label>First Name</label>
                      <input
                        type="text"
                        placeholder="First Name (in French letters)"
                        value={addAppObject?.patientFirstName}
                        onChange={(e) =>
                          setAddAppObject((prev) => ({
                            ...prev,
                            patientFirstName: e.target.value,
                          }))
                        }
                      />
                    </li>
                    <li>
                      <label>Last Name</label>
                      <input
                        type="text"
                        placeholder="Last Name (in French letters)"
                        value={addAppObject?.patientLastName}
                        onChange={(e) =>
                          setAddAppObject((prev) => ({
                            ...prev,
                            patientLastName: e.target.value,
                          }))
                        }
                      />
                    </li>
                    <li>
                      <label>Gender</label>
                      <select
                        value={addAppObject?.patientGender}
                        onChange={(e) =>
                          setAddAppObject((prev) => ({
                            ...prev,
                            patientGender: e.target.value,
                          }))
                        }
                      >
                        <option value="" disabled selected>
                          Select Gender
                        </option>
                        <option value={"male"}>Male</option>
                        <option value={"female"}>Female</option>
                        {/* <option value={"other"}>Other</option> */}
                      </select>
                    </li>
                    <li>
                      <label>City</label>
                      <select
                        value={addAppObject?.patientCity}
                        onChange={(e) =>
                          setAddAppObject((prev) => ({
                            ...prev,
                            patientCity: e.target.value,
                          }))
                        }
                      >
                        <option value="" disabled selected>
                          Select city
                        </option>
                        {cityList?.map((item, index) => (
                          <option key={index} value={item?.id}>
                            {item?.name}
                          </option>
                        ))}
                      </select>
                    </li>
                    <li className="dateOfBirthCont">
                      <label>Date of Birth</label>
                      <ul>
                        <li>
                          <select
                            value={addAppObject?.patientMonth}
                            onChange={(e) =>
                              setAddAppObject((prev) => ({
                                ...prev,
                                patientMonth: e.target.value,
                              }))
                            }
                          >
                            <option value="" disabled selected>
                              Month
                            </option>
                            {months?.map((item, index) => (
                              <option
                                key={index}
                                value={
                                  index + 1 < 10 ? "0" + (index + 1) : index + 1
                                }
                              >
                                {item}
                              </option>
                            ))}
                          </select>
                        </li>
                        <li>
                          <select
                            value={addAppObject?.patientDay}
                            onChange={(e) =>
                              setAddAppObject((prev) => ({
                                ...prev,
                                patientDay: e.target.value,
                              }))
                            }
                          >
                            <option value="" disabled selected>
                              Day
                            </option>
                            {daysarray?.map((item, index) => (
                              <option key={index} value={item}>
                                {item}
                              </option>
                            ))}
                          </select>
                        </li>
                        <li>
                          <select
                            value={addAppObject?.patientYear}
                            onChange={(e) =>
                              setAddAppObject((prev) => ({
                                ...prev,
                                patientYear: e.target.value,
                              }))
                            }
                          >
                            <option value="" disabled selected>
                              Year
                            </option>
                            {years?.map((year, index) => (
                              <option key={index} value={year}>
                                {year}
                              </option>
                            ))}
                          </select>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <label>Phone Number</label>
                      <input
                        type="number"
                        placeholder="Phone Number"
                        value={addAppObject?.patientNumber}
                        onChange={(e) =>
                          setAddAppObject((prev) => ({
                            ...prev,
                            patientNumber: e.target.value,
                          }))
                        }
                      />
                    </li>
                    <li>
                      <label>Id Number</label>
                      <input
                        type="number"
                        placeholder="Id Number"
                        value={addAppObject?.idNumber}
                        onChange={(e) =>
                          setAddAppObject((prev) => ({
                            ...prev,
                            idNumber: e.target.value,
                          }))
                        }
                      />
                    </li>
                    <li>
                      <label>Birth City</label>
                      <select
                        value={addAppObject?.birthCity}
                        onChange={(e) =>
                          setAddAppObject((prev) => ({
                            ...prev,
                            birthCity: e.target.value,
                          }))
                        }
                      >
                        <option value="" disabled selected>
                          Select birth city
                        </option>
                        {cityList?.map((item, index) => (
                          <option key={index} value={item?.id}>
                            {item?.name}
                          </option>
                        ))}
                      </select>
                    </li>
                    <li>
                      <div className="btnGroup">
                        <button
                          className="startBtn"
                          disabled={
                            !addAppObject?.patientFirstName ||
                            !addAppObject?.patientLastName ||
                            !addAppObject?.patientGender ||
                            !addAppObject?.patientCity ||
                            !addAppObject?.patientMonth ||
                            !addAppObject?.patientDay ||
                            !addAppObject?.patientYear ||
                            !addAppObject?.patientNumber ||
                            !addAppObject?.idNumber ||
                            !addAppObject?.birthCity
                          }
                          onClick={() =>
                            handleAddAppointmentFromPopup(
                              "",
                              childId && allPatientChildDetails
                                ? allPatientChildDetails?.data[0]
                                : allPatientDetails?.data[0],
                            )
                          }
                        >
                          Validate profile & start consultation
                        </button>
                        <button
                          className="startBtn"
                          disabled={
                            !addAppObject?.patientFirstName ||
                            !addAppObject?.patientLastName
                          }
                          onClick={() =>
                            handleAddAppointmentFromPopup(
                              "without-tracking",
                              childId && allPatientChildDetails
                                ? allPatientChildDetails?.data[0]
                                : allPatientDetails?.data[0],
                            )
                          }
                        >
                          Start consultation without tracking
                        </button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        )}
        {reschedulePopupShow && (
          <div className="popup holidayPopup ReschedulePopup">
            <div className="popup-content">
              <button
                onClick={() => {
                  setReschedulePopupShow(false);
                  setCalendarValue(new Date());
                }}
                className="cancelBtn"
              >
                <img src={cancelIcon} alt="cancelIcon" />
              </button>
              <div className="popupInner">
                <div className="calendar-section">
                  <h3>Choose Date and Time</h3>
                  <div className="overlayBtn"></div>
                  <Calendar
                    onChange={handleDateClick}
                    value={calendarValue}
                    tileClassName={tileClassName}
                    onActiveStartDateChange={handleActiveStartDateChange}
                    minDate={new Date()}
                  />
                </div>
                <div className="selected-dates">
                  <div className="TopHead">
                    <h3>
                      {format(calendarValue, "EEEE")}{" "}
                      <span>{format(calendarValue, "MMMM d, yyyy")}</span>
                    </h3>
                    <p>Available Time Slot</p>
                  </div>
                  {skelLoading ? (
                    <div className="SkelWrapper">
                      <Skeleton
                        count={2}
                        height={20}
                        width={"80%"}
                        baseColor="#cfd5f9"
                      />
                    </div>
                  ) : (
                    <ul>
                      {availDates?.length > 0 &&
                        !moment(calendarValue).isSameOrAfter(futureDate) ? (
                        availDates?.map((item, index) => {
                          const currentTime = moment().add(1, "hour");
                          const isToday = moment(calendarValue).isSame(
                            currentTime,
                            "day",
                          );
                          return (
                            // <li key={index} className={selectedTime === item ? "active" : ""} onClick={() => setSelectedTime(item)}>
                            item?.has_interval === 1 ? (
                              isToday ? (
                                moment(item?.start_time, "HH:mm").isSameOrAfter(
                                  currentTime,
                                ) ? (
                                  <li
                                    key={index}
                                    className={
                                      selectedTime ===
                                        item?.start_time + "-" + item?.end_time
                                        ? "active"
                                        : ""
                                    }
                                    onClick={() => handleSelectTime(item)}
                                  >
                                    <span>
                                      {item?.start_time} to {item?.end_time}
                                    </span>
                                  </li>
                                ) : null
                              ) : (
                                <li
                                  key={index}
                                  className={
                                    selectedTime ===
                                      item?.start_time + "-" + item?.end_time
                                      ? "active"
                                      : ""
                                  }
                                  onClick={() => handleSelectTime(item)}
                                >
                                  <span>
                                    {item?.start_time} to {item?.end_time}
                                  </span>
                                </li>
                              )
                            ) : (
                              generateTimeSlots(
                                item?.start_time,
                                item?.end_time,
                                item?.intervals,
                                item?.time_slot_type,
                              ).map((timeItem, timeIndex) => {
                                if (isToday) {
                                  if (
                                    moment(timeItem, "HH:mm").isSameOrAfter(
                                      currentTime,
                                    )
                                  ) {
                                    return (
                                      <li
                                        key={timeIndex}
                                        className={
                                          selectedTime === timeItem
                                            ? "active"
                                            : ""
                                        }
                                        onClick={() =>
                                          handleSelectTime(timeItem)
                                        }
                                      >
                                        <span>{timeItem}</span>
                                      </li>
                                    );
                                  } else {
                                    return null;
                                  }
                                } else {
                                  return (
                                    <li
                                      key={timeIndex}
                                      className={
                                        selectedTime === timeItem
                                          ? "active"
                                          : ""
                                      }
                                      onClick={() => handleSelectTime(timeItem)}
                                    >
                                      <span>{timeItem}</span>
                                    </li>
                                  );
                                }
                              })
                            )
                          );
                        })
                      ) : (
                        <p>No times available for this day.</p>
                      )}
                    </ul>
                  )}
                  <button
                    className="saveBtn2"
                    onClick={() =>
                      handleSchedule(
                        childId && allPatientChildDetails
                          ? allPatientChildDetails?.data[0]
                          : allPatientDetails?.data[0],
                      )
                    }
                    disabled={modalBtnDis}
                  >
                    {modalBtnDis ? "Please wait..." : "Submit"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default NewPatientDictonary;
